/* Insigne Personalizer — Faz 1.2 (Studio Light · gerçek PDP entegrasyonu)
   AKIŞ (Ali 2026-07-27): 1) Ölçü&Şekil → 2) Görsel → 3) Önizleme.
   Ölçü ÖNCE gelir ki kırpma/yerleştirme tek sefer ve anlamlı olsun.
   Veriler GERÇEK üründen (custom-print-on-glass, Admin API 2026-07-27). */
(function () {
  'use strict';

  /* Shopify temasında IP_CONFIG section'dan gelir (API kökü + tema asset URL'leri);
     yerel geliştirmede tanımsızdır ve her şey aynı klasörden servis edilir. */
  var CFG = window.IP_CONFIG || {};
  var API = CFG.api || '';
  var IN = 25.4, DPI = 150, BLEED_MM = 5; // Ali: tasmali baski, yarimsar cm/kenar (TUM urunler)

  /* Gerçek ürün verisi → FORMATLAR (şekil+yön, tek dokunuşluk estetik seçim).
     Aynı formatın ölçüleri aynı orana yakın → ölçü, görselle AYNI adımda seçilir. */
  var FORMATS = [
    { id: 'rl', name: 'Landscape', product: 'Rectangular', kind: 'rect', ar: 28.5 / 18, sizes: [
      { id: 'r1', label: '28.5"×18"', sub: '72×46 cm', w: 720, h: 460,   price: 179.90, was: 239.90 },
      { id: 'r5', label: '35"×24"',   sub: '90×60 cm', w: 900,   h: 600,   price: 219.90, was: 299.90 },
      { id: 'r3', label: '43"×27.5"', sub: '110×70 cm', w: 1100,  h: 700, price: 289.90, was: 389.90 },
      { id: 'r7', label: '55"×35"',   sub: '140×90 cm', w: 1400,  h: 900,   price: 589.90, was: 789.90 },
    ] },
    { id: 'rp', name: 'Portrait', product: 'Rectangular', kind: 'rect', ar: 18 / 28.5, sizes: [
      { id: 'r2', label: '18"×28.5"', sub: '46×72 cm', w: 460,   h: 720, price: 179.90, was: 239.90 },
      { id: 'r6', label: '24"×35"',   sub: '60×90 cm', w: 600,   h: 900,   price: 219.90, was: 299.90 },
      { id: 'r4', label: '27.5"×43"', sub: '70×110 cm', w: 700, h: 1100,  price: 289.90, was: 389.90 },
      { id: 'r8', label: '35"×55"',   sub: '90×140 cm', w: 900,  h: 1400,   price: 589.90, was: 789.90 },
    ] },
    { id: 'sq', name: 'Square', product: 'Square', kind: 'rect', ar: 1, sizes: [
      { id: 's1', label: '15"×15"', sub: '40×40 cm',  w: 400, h: 400, price: 119.90, was: 159.90 },
      { id: 's2', label: '20"×20"', sub: '50×50 cm',  w: 500, h: 500, price: 129.90, was: 179.90 },
      { id: 's3', label: '24"×24"', sub: '60×60 cm',  w: 600, h: 600, price: 169.90, was: 224.90 },
      { id: 's4', label: '32"×32"', sub: '80×80 cm',  w: 800, h: 800, price: 249.90, was: 329.90 },
      { id: 's5', label: '40"×40"', sub: '100×100 cm', w: 1000, h: 1000, price: 369.90, was: 488.90 },
    ] },
    { id: 'rd', name: 'Round', product: 'Round', kind: 'round', ar: 1, sizes: [
      { id: 'o1', label: 'Ø 24"', sub: '60 cm',  w: 24 * IN, h: 24 * IN, price: 179.90, was: 239.90 },
      { id: 'o2', label: 'Ø 32"', sub: '80 cm',  w: 32 * IN, h: 32 * IN, price: 269.90, was: 359.90 },
      { id: 'o3', label: 'Ø 40"', sub: '100 cm', w: 40 * IN, h: 40 * IN, price: 379.90, was: 499.90 },
    ] },
    /* ⚠ cm ALT ETİKETİ DÜZELTİLDİ (2026-10-07): dikey 12"×35" tahtanın altında
       "90×30 cm" yazıyordu — ters. Katalogdaki diğer her formatta cm etiketi
       inçle AYNI sırada (28.5"×18" → 72×46 cm). Yatay kardeşi eklenince bu
       hata görünür hâle geliyordu: ikisi de "90×30 cm" diyecekti ve müşteri
       dikeyle yatayı cm'den ayırt edemeyecekti. Shopify'daki ölçü değeri inç
       etiketi olduğu için bu düzeltme yalnız editördeki alt yazıyı değiştirir. */
    { id: 'sb', name: 'Surfboard', product: 'Surfboard', kind: 'surf', ar: 12 / 35, sizes: [
      { id: 'b1', label: '12"×35"', sub: '30×90 cm',  w: 300, h: 900, price: 169.90, was: 229.90 },
      { id: 'b2', label: '16"×47"', sub: '40×120 cm', w: 400, h: 1200, price: 239.90, was: 319.90 },
    ] },
    /* YATAY SÖRF (Ali 2026-10-07). Aynı cam, aynı alan, aynı kesim işçiliği →
       fiyat dikeyle BİREBİR aynı; farklı fiyat müşteriye tutarsız görünürdü.
       Silüet gerilmiyor, 90° dönüyor (bkz. surfPathD). */
    { id: 'sl', name: 'Surfboard Landscape', product: 'Surfboard', kind: 'surf', ar: 35 / 12, sizes: [
      { id: 'b3', label: '35"×12"', sub: '90×30 cm',  w: 900,  h: 300, price: 169.90, was: 229.90 },
      { id: 'b4', label: '47"×16"', sub: '120×40 cm', w: 1200, h: 400, price: 239.90, was: 319.90 },
    ] },
    { id: 'pl', name: 'Panoramic', product: 'Panoramic', kind: 'rect', ar: 36 / 14, sizes: [
      { id: 'p1', label: '36"×14"', sub: '92×36 cm', w: 36 * IN, h: 14 * IN, price: 169.90, was: 269.90 },
    ] },
    { id: 'pp', name: 'Pano Portrait', product: 'Panoramic', kind: 'rect', ar: 14 / 36, sizes: [
      { id: 'p2', label: '14"×36"', sub: '36×92 cm', w: 14 * IN, h: 36 * IN, price: 169.90, was: 269.90 },
    ] },
    /* ÇOK-PARÇALI (Ali): tek görsel N panele bölünür, aralar 10mm boşluk, desen kesintisiz sürer.
       Ölçü = TOPLAM alan; render'da her panel ayrı dosya (boşluk bantları basılmaz). Sadece CAM. */
    { id: 'mega3', name: 'Triptych', product: 'Mega 3-Piece', kind: 'multi',
      panels: { layout: 'row', count: 3, gap_mm: 10 }, ar: 55 / 28.5, sizes: [
      { id: 'm1', label: '55"×28.5"', sub: '140×72 cm · 3 panels',  w: 1400,  h: 720, price: 539.90,  was: 719.90 },
      { id: 'm2', label: '72"×35"',   sub: '182×90 cm · 3 panels',  w: 1820,  h: 900,   price: 659.90,  was: 869.90 },
      { id: 'm3', label: '84"×43"',   sub: '212×110 cm · 3 panels', w: 2120,  h: 1100,   price: 869.90,  was: 1149.90 },
      { id: 'm4', label: '107"×55"',  sub: '272×140 cm · 3 panels', w: 2720, h: 1400,   price: 1769.90, was: 2339.90 },
    ] },
    /* Quadro 2×2 — Ali fiyat listesi 2026-07-28: TOPLAM inç etiketi, parça cm alt bilgi.
       toplam = 2×parça + 30mm boşluk (Ali 2026-08-11, TR kataloğu); her panel kendi alanından aparat sayısı. */
    { id: 'quadSq', name: 'Quadro 2×2', product: 'Quadro 4-Piece', kind: 'multi',
      panels: { layout: 'grid', cols: 2, rows: 2, gap_mm: 30 }, ar: 1, sizes: [
      { id: 'qs1', label: '32"×32"', sub: '83×83 cm · 4 panels',   w: 2 * 400 + 30,  h: 2 * 400 + 30,  price: 399.90,  was: 529.90 },
      { id: 'qs2', label: '40"×40"', sub: '103×103 cm · 4 panels',   w: 2 * 500 + 30,  h: 2 * 500 + 30,  price: 439.90,  was: 579.90 },
      { id: 'qs3', label: '48"×48"', sub: '123×123 cm · 4 panels',   w: 2 * 600 + 30,  h: 2 * 600 + 30,  price: 479.90,  was: 639.90 },
      { id: 'qs4', label: '64"×64"', sub: '163×163 cm · 4 panels',   w: 2 * 800 + 30,  h: 2 * 800 + 30,  price: 879.90,  was: 1169.90 },
      { id: 'qs5', label: '80"×80"', sub: '203×203 cm · 4 panels', w: 2 * 1000 + 30, h: 2 * 1000 + 30, price: 1359.90, was: 1799.90 },
    ] },
    /* QUADRO YATAY (Ali fiyat 2026-07-28): 4 dikey panel (~36×92 cm), 10mm boşluk, toplam 59×36". */
    { id: 'quadH', name: 'Quadro Wide', product: 'Quadro 4-Piece', kind: 'multi',
      panels: { layout: 'row', count: 4, gap_mm: 10 }, ar: 59 / 36, sizes: [
      { id: 'qw1', label: '59"×36"', sub: '150×92 cm · 4 panels', w: 1500, h: 920, price: 679.90, was: 899.90 },
    ] },
  ];

  /* Malzemeler (Ali 2026-07-27: cam + alüminyum + fırçalı alu + rulo kanvas) */
  /* ═══ ÇEVİRİ (i18n) ══════════════════════════════════════════════════════════
     Editörün metinleri JS içinde sabitti; /tr /de gibi dillerde İngilizce kalıyordu
     (Ali 2026-07-31). Çeviriler `window.IP_T` ile Liquid'den geliyor (bölüm şablonu
     locale dosyalarından basıyor). Anahtar yoksa İNGİLİZCESİ kullanılır — yani
     çeviri eksik olsa bile editör hiçbir zaman boş metin göstermez. */
  /* IP_VARLIK_COZ - HTML varlik cozumleme (Ali 2026-08-17)
     Ekranda "It&#39;s also the image you&#39;ll see..." gorunuyordu.
     Cevirıler Liquid'den {{ 'insigne.x' | t | json }} ile geliyor; `t` filtresi
     HTML KACISI YAPAR (' -> &#39;). JS bunu textContent ile basinca varlik
     COZULMEZ, harfi harfine gorunur. TR'de fark edilmiyordu cunku Turkce
     metinlerde kesme isareti yoktu; Ingilizcede her cumlede var.
     TEK NOKTADA cozulur -> tum anahtarlar ve tum diller birden duzelir.
     (Liquid'de tek tek `replace` yazmak 1200 anahtar icin surdurulemez.) */
  var _ipCozKutu = null;
  function ipVarlikCoz(s) {
    if (typeof s !== 'string' || s.indexOf('&') < 0) return s;
    if (!_ipCozKutu) _ipCozKutu = document.createElement('textarea');
    _ipCozKutu.innerHTML = s;
    return _ipCozKutu.value;
  }
  function IPT(key, fallback) {
    var d = window.IP_T || {};
    /* ⚠ BOŞ STRING GEÇERLİ BİR ÇEVİRİDİR (Ali 2026-08-02): Türkçe/Japonca/Korecede
       fiyat önündeki "From " karşılığı YOK — boş bırakılmıştı, ama burada boş değer
       "eksik" sayılıp İNGİLİZCESİ basılıyordu ("From $179.90"). Artık yalnız anahtar
       TANIMSIZSA yedeğe düşülür. */
    return ipVarlikCoz((d[key] === undefined || d[key] === null) ? fallback : d[key]);
  }

  /* Ölçü alt yazısındaki İngilizce ek ("· 3 panels", "×4") YALNIZ EKRANDA çevrilir.
     Veri (v.sub) İngilizce kalır: reçeteye `size_sub` olarak gidiyor ve `sizeCm()`
     onu ayrıştırıp `size_cm` üretiyor — çevirsek üretim tarafı bozulurdu. */
  function subTr(x) {
    if (!x) return x;
    return String(x)
      .replace('· 3 panels', IPT('ipj_panels_3', '· 3 panels'))
      .replace('· 4 panels', IPT('ipj_panels_4', '· 4 panels'))
      ;   /* ×4 değişimi KALDIRILDI (Ali 2026-08-19): "60×40 cm" içindeki ×4'ü de
             yakalayıp "60×4 parça0 cm" üretiyordu. Çok panelli alt yazıları artık
             "· N panels" biçiminde olduğu için bu değişime gerek yok. */
  }

  /* ÇOK PANELLİ ÖLÇÜ (Ali 2026-08-19): "150×92 cm · 4 parça" her PARÇANIN o ölçüde
     olduğu izlenimi veriyordu. Ölçü artık TOPLAM montaj ölçüsüdür (inç etiketi zaten
     öyleydi) ve başına "Toplam" konur. Tek panelli ürünlerde davranış DEĞİŞMEZ.
     İnç modunda parça sayısı etikette yok — orada da eklenir. */
  function olcuBas(v, fmt) {
    var cmVar = (window.INS_UNIT === 'cm') && v.sub;
    var s = cmVar ? subTr(v.sub) : v.label;
    var p = fmt && fmt.panels;
    if (!p) return s;
    var adet = p.count || ((p.cols || 1) * (p.rows || 1));
    if (!cmVar) s += ' ' + IPT('ipj_panels_' + adet, '\u00b7 ' + adet + ' panels');
    return IPT('ipj_total', 'Total') + ' ' + s;
  }

  /* Parça başına ölçü — TOPLAMDAN ve gerçek boşluklardan hesaplanır (Ali 2026-08-19).
     "Toplam 150×92 cm · 4 parça" tek başına, HER PARÇA 150×92 sanılmasına yol açıyordu. */
  function ipSayi(x) {
    var r = Math.round(x * 10) / 10;
    try { return r.toLocaleString(undefined, { maximumFractionDigits: 1 }); }
    catch (e) { return String(r); }
  }
  function ipOlcuCift(wmm, hmm) {
    if (window.INS_UNIT === 'cm') return ipSayi(wmm / 10) + '\u00d7' + ipSayi(hmm / 10) + ' cm';
    return ipSayi(wmm / 25.4) + '"\u00d7' + ipSayi(hmm / 25.4) + '"';
  }
  function parcaOlcu(v, fmt) {
    var p = fmt && fmt.panels;
    if (!p) return '';
    var g = p.gap_mm || 0;
    var sut = p.cols || p.count || 1, sat = p.rows || 1;
    var adet = p.count || (sut * sat);
    var pw = (v.w - (sut - 1) * g) / sut;
    var ph = (v.h - (sat - 1) * g) / sat;
    if (!(pw > 0 && ph > 0)) return '';
    return '(' + ipOlcuCift(pw, ph) + ' \u00d7 ' + adet + ')';
  }




  var MATERIALS = {
    glass:    { slug: 'tempered-glass',    name: 'Tempered Glass', surface: 'glass',
      note: 'This is exactly what will be printed. It\'s also the image you\'ll see in your cart and order e-mail.',
      strip: ['Tempered glass', 'Mounting hardware included', '0% fade indoors'] },
    aluminum: { slug: 'aluminum',         name: 'Aluminum', surface: 'aluminum',
      note: 'This is exactly what will be printed on rigid aluminum — shatterproof and featherlight.',
      strip: ['Aluminum composite', 'Mounting hardware included', '0% fade indoors'] },
    brushed:  { slug: 'brushed-aluminum', name: 'Brushed Aluminum', surface: 'brushed aluminum',
      note: 'Printed on brushed aluminum — bright areas pick up a subtle metallic sheen.',
      strip: ['Brushed aluminum composite', 'Mounting hardware included', '0% fade indoors'] },
    /* orientFree: yön ÜRÜNÜ değiştirmez (çerçevesiz gönderilir, yalnız logo yerleşimi
       kayar) → format ızgarasında Yatay/Dikey diye iki karo göstermeyiz; yön, ölçünün
       hemen üstünde sorulur ve yalnız KIRPMAYI belirler (Ali 2026-07-30). */
    canvas:   { slug: 'rolled-canvas',     name: 'Rolled Canvas', surface: 'canvas', orientFree: true,
      note: 'Printed on artist canvas with stretching margins included, shipped safely rolled in a protective tube — have it stretched or framed locally.',
      strip: ['Artist canvas', 'Stretching margins included', 'Ships rolled in a tube'] },
  };

  /* format ve malzeme adlarını çeviriyle değiştir (tanımlar yukarıda İngilizce kalır;
     böylece IP_T yüklenmezse ekran yine dolu olur) */
  (function () {
    /* ⚠ Kimlikler FORMATS tablosuyla BİREBİR olmalı. Önceden sf/pn/tr/q22/qw yazıyordu;
   tablodaki karşılıkları sb/pl/mega3/quadSq/quadH olduğu için bu beş formatın adı
   hiç çevrilmiyor, Türkçe sitede 'Surfboard/Panoramic/Triptych/Quadro' kalıyordu. */
    var FK = { rl:'ipj_landscape', rp:'ipj_portrait', sq:'ipj_square', rd:'ipj_round',
               sb:'ipj_surfboard', sl:'ipj_surfboard_ls', pl:'ipj_panoramic', pp:'ipj_panoport',
               mega3:'ipj_triptych', quadSq:'ipj_quadro22', quadH:'ipj_quadrowide' };
    FORMATS.forEach(function (f) { if (FK[f.id]) f.name = IPT(FK[f.id], f.name); });
    /* `product` hiç çeviriye bağlı değildi — son özet satırında İngilizce basılıyordu. */
    var PK = { 'Rectangular':'ipj_p_rect', 'Square':'ipj_p_square', 'Round':'ipj_p_round',
               'Surfboard':'ipj_p_surf', 'Panoramic':'ipj_p_pano',
               'Mega 3-Piece':'ipj_p_mega3', 'Quadro 4-Piece':'ipj_p_quad4' };
    FORMATS.forEach(function (f) { if (PK[f.product]) f.product = IPT(PK[f.product], f.product); });
    var MK = { glass:'ipj_glass', aluminum:'ipj_alu', brushed:'ipj_brushed', canvas:'ipj_canvas' };
    Object.keys(MK).forEach(function (k) { if (MATERIALS[k]) MATERIALS[k].name = IPT(MK[k], MATERIALS[k].name); });
    /* ⚠ SAHNE ALTINDAKİ AÇIKLAMA NOTU da çevrilmemişti (Ali 2026-08-13):
       MATERIALS tablosunda `name` ve `strip` çeviriye bağlıyken `note`
       hiç bağlanmamış, dört malzemede de İngilizce basılıyordu. */
    var NK = { glass:'ipj_note_glass', aluminum:'ipj_note_alu',
               brushed:'ipj_note_brushed', canvas:'ipj_note_canvas' };
    Object.keys(NK).forEach(function (k) { if (MATERIALS[k]) MATERIALS[k].note = IPT(NK[k], MATERIALS[k].note); });
    /* ⚠ GÜVEN ŞERİDİ de çevrilmemişti (Ali 2026-08-02): sahnenin altındaki
       "Tempered glass · Mounting hardware included · 0% fade indoors" satırı /tr'de
       İngilizce kalıyordu. Metinler veri tablosunda İngilizce DURUR (yedek), burada çevrilir. */
    var SK = {
      'Tempered glass':'ipj_st_glass', 'Aluminum composite':'ipj_st_alucomp',
      'Brushed aluminum composite':'ipj_st_brushcomp', 'Artist canvas':'ipj_st_canvas',
      'Mounting hardware included':'ipj_st_mount', '0% fade indoors':'ipj_st_fade',
      'Stretching margins included':'ipj_st_stretch', 'Ships rolled in a tube':'ipj_st_tube'
    };
    Object.keys(MATERIALS).forEach(function (k) {
      var m = MATERIALS[k];
      if (m && m.strip) m.strip = m.strip.map(function (x) { return SK[x] ? IPT(SK[x], x) : x; });
    });
  })();

  /* MALZEME-BAZLI ölçü/fiyat (Ali: her malzemenin kendi ölçüleri var; custom = katalog + ~%10).
     ALU GERÇEK katalog (brushed dibond ürünleri, 2026-07-27): SADECE KARE 15/24/31/45".
     KANVAS: katalogda yok — GEÇİCİ katsayı (cam×0.6), Ali fiyat listesi gelince değişecek. */
  var SIZES_ALT = {
    /* BEYAZ ALUMINUM — yalnız dikey dikdörtgen (Ali fiyat listesi 2026-07-27) */
    aluminum: { rp: [
      { id: 'w1', label: '23.5"×35"',   sub: '90×60 cm',  w: 600, h: 900,    price: 219.90, was: 289.90 },
      { id: 'w2', label: '29.5"×45.45"', sub: '115×75 cm', w: 750, h: 1150, price: 279.90, was: 359.90 },
    ] },
    /* SATINE (BRUSHED) ALUMINUM — yatay rect + kare (Ali fiyat listesi) */
    brushed: {
      rl: [
        { id: 'g1', label: '23.5"×15.5"', sub: '60×39 cm',  w: 600, h: 390, price: 109.90, was: 159.90 },
        { id: 'g2', label: '35"×23.5"',   sub: '90×60 cm',  w: 900,   h: 600, price: 229.90, was: 319.90, pop: true },
        { id: 'g3', label: '45.5"×29.5"', sub: '115×75 cm', w: 1150, h: 750, price: 299.90, was: 399.90 },
      ],
      sq: [
        { id: 'g4', label: '15"×15"', sub: '40×40 cm',   w: 400, h: 400, price: 99.90,  was: 139.90 },
        { id: 'g5', label: '24"×24"', sub: '60×60 cm',   w: 600, h: 600, price: 149.90, was: 189.90 },
        { id: 'g6', label: '31"×31"', sub: '79×79 cm',   w: 790, h: 790, price: 249.90, was: 329.90 },
        { id: 'g7', label: '45"×45"', sub: '115×115 cm', w: 1150, h: 1150, price: 359.90, was: 479.90 },
      ],
    },
    /* KANVAS (gerdirilmemiş) — 11 ölçü, yatay + dikey (Ali fiyat listesi) */
    canvas: {
      rl: [
        { id: 'cl0', label: '12"×8"', sub: '30×20 cm', w: 12 * IN, h: 8 * IN, price: 89.9, was: 139.9 },
        { id: 'cl1', label: '18"×12"', sub: '45×30 cm', w: 18 * IN, h: 12 * IN, price: 99.9, was: 159.9 },
        { id: 'cl2', label: '24"×16"', sub: '60×40 cm', w: 24 * IN, h: 16 * IN, price: 109.9, was: 179.9 },
        { id: 'cl3', label: '30"×20"', sub: '75×50 cm', w: 30 * IN, h: 20 * IN, price: 119.9, was: 189.9 },
        { id: 'cl4', label: '36"×24"', sub: '90×60 cm', w: 36 * IN, h: 24 * IN, price: 139.9, was: 219.9 },
        { id: 'cl5', label: '40"×26"', sub: '100×65 cm', w: 40 * IN, h: 26 * IN, price: 159.9, was: 249.9 },
        { id: 'cl6', label: '45"×30"', sub: '115×75 cm', w: 45 * IN, h: 30 * IN, price: 169.9, was: 269.9 },
        { id: 'cl7', label: '48"×32"', sub: '120×80 cm', w: 48 * IN, h: 32 * IN, price: 189.9, was: 299.9 },
        { id: 'cl8', label: '54"×36"', sub: '135×90 cm', w: 54 * IN, h: 36 * IN, price: 239.9, was: 379.9 },
        { id: 'cl9', label: '60"×40"', sub: '150×100 cm', w: 60 * IN, h: 40 * IN, price: 259.9, was: 399.9 },
        { id: 'cl10', label: '72"×48"', sub: '180×120 cm', w: 72 * IN, h: 48 * IN, price: 359.9, was: 559.9 },
      ],
      rp: [
        { id: 'cp0', label: '8"×12"', sub: '20×30 cm', w: 8 * IN, h: 12 * IN, price: 89.9, was: 139.9 },
        { id: 'cp1', label: '12"×18"', sub: '30×45 cm', w: 12 * IN, h: 18 * IN, price: 99.9, was: 159.9 },
        { id: 'cp2', label: '16"×24"', sub: '40×60 cm', w: 16 * IN, h: 24 * IN, price: 109.9, was: 179.9 },
        { id: 'cp3', label: '20"×30"', sub: '50×75 cm', w: 20 * IN, h: 30 * IN, price: 119.9, was: 189.9 },
        { id: 'cp4', label: '24"×36"', sub: '60×90 cm', w: 24 * IN, h: 36 * IN, price: 139.9, was: 219.9 },
        { id: 'cp5', label: '26"×40"', sub: '65×100 cm', w: 26 * IN, h: 40 * IN, price: 159.9, was: 249.9 },
        { id: 'cp6', label: '30"×45"', sub: '75×115 cm', w: 30 * IN, h: 45 * IN, price: 169.9, was: 269.9 },
        { id: 'cp7', label: '32"×48"', sub: '80×120 cm', w: 32 * IN, h: 48 * IN, price: 189.9, was: 299.9 },
        { id: 'cp8', label: '36"×54"', sub: '90×135 cm', w: 36 * IN, h: 54 * IN, price: 239.9, was: 379.9 },
        { id: 'cp9', label: '40"×60"', sub: '100×150 cm', w: 40 * IN, h: 60 * IN, price: 259.9, was: 399.9 },
        { id: 'cp10', label: '48"×72"', sub: '120×180 cm', w: 48 * IN, h: 72 * IN, price: 359.9, was: 559.9 },
      ],
      /* ⭐ KARE KANVAS (Ali onayı 2026-08-03). Fiyatlar Ali'nin MEVCUT dikdörtgen kanvas
         merdivenine oturtularak çıkarıldı (alan-bazlı interpolasyon) — böylece hiçbir kare,
         kendinden büyük bir dikdörtgenden pahalı değil (ters sıralama 0 doğrulandı).
         24"×24" ALTI Ali'nin talimatıyla eklenmedi. Yön seçici karede otomatik gizlenir
         (renderOrient yalnız rl/rp'de gösteriyor). */
      sq: [
        { id: 'cs0', label: '24"×24"', sub: '61×61 cm',    w: 24 * IN, h: 24 * IN, price: 117.90, was: 187.90 },
        { id: 'cs1', label: '30"×30"', sub: '76×76 cm',    w: 30 * IN, h: 30 * IN, price: 143.90, was: 225.90 },
        { id: 'cs2', label: '36"×36"', sub: '91×91 cm',    w: 36 * IN, h: 36 * IN, price: 167.90, was: 265.90 },
        { id: 'cs3', label: '40"×40"', sub: '102×102 cm',  w: 40 * IN, h: 40 * IN, price: 196.90, was: 311.90 },
        { id: 'cs4', label: '48"×48"', sub: '122×122 cm',  w: 48 * IN, h: 48 * IN, price: 254.90, was: 394.90 },
      ],
    },
  };
  /* bir ölçüyü diğer yöne ÇEVİR (Ali: her ölçünün yatay+dikeyi olsun; sadece w/h+etiket takası) */
  function flipLabel(lab) {
    var m = lab.match(/^([\d.]+)"×([\d.]+)"(.*)$/);
    return m ? m[2] + '"×' + m[1] + '"' + m[3] : lab;
  }
  function flipSub(sub) {
    var m = sub && sub.match(/^([\d.]+)×([\d.]+)( cm)$/);
    return m ? m[2] + '×' + m[1] + m[3] : sub;
  }
  function flipSizes(list) {
    return list.map(function (s) {
      return Object.assign({}, s, { id: s.id + 'F', w: s.h, h: s.w,
        label: flipLabel(s.label), sub: flipSub(s.sub) });
    });
  }
  var FLIP = { rl: 'rp', rp: 'rl' };                    // yatay↔dikey format eşi
  function sizesFor(mat, fmtId) {
    if (mat === 'glass') {
      var f = null;
      FORMATS.forEach(function (x) { if (x.id === fmtId) f = x; });
      return f ? f.sizes : null;                        // cam: TAM set (Round YALNIZ camda)
    }
    var alt = SIZES_ALT[mat];
    if (!alt) return null;
    if (alt[fmtId]) return alt[fmtId];                  // doğrudan tanımlı
    if (FLIP[fmtId] && alt[FLIP[fmtId]]) return flipSizes(alt[FLIP[fmtId]]); // ters yönü çevir
    return null;
  }

  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
  function renderStrip() {
    document.getElementById('ip-strip').innerHTML = MATERIALS[state.material].strip
      .map(function (t) { return '<span>' + CHECK_SVG + t + '</span>'; }).join('');
    var et = document.querySelector('.ip-empty-t');
    /* ⚠ bu satır boş-durum yazısını JS ile EZİYOR; çevirisizdi → /tr'de İngilizce görünüyordu */
    /* ⚠ Şablonlu çeviri: malzeme adı cümlenin İÇİNE girer ({m}). Eskiden İngilizce
       önek + İngilizce yüzey adı birleştiriliyordu → /tr'de "Your artwork, live on glass". */
    if (et) {
      var _srf = IPT('ipj_srf_' + state.material, MATERIALS[state.material].surface);
      et.textContent = IPT('ipj_live_tpl', 'Your artwork, live on {m}').replace('{m}', _srf);
    }
  }


  /* Surfboard dış hattı — Ali'nin PDF çiziminden BİREBİR çıkarılmış vektör (normalize 0..1) */
  var SURF_EXACT = {"start": [0.8962, 0.1864], "curves": [[0.7689, 0.047, 0.5538, 0.0076, 0.512, 0.0011], [0.507, 0.0004, 0.5016, 0.0, 0.4962, 0.0], [0.4909, 0.0, 0.4855, 0.0004, 0.4805, 0.0011], [0.4387, 0.0076, 0.2236, 0.047, 0.0964, 0.1864], [0.0323, 0.2566, 0.0, 0.3414, 0.0, 0.4388], ["L", 0.0, 0.4392], [0.0, 0.4512, 0.0005, 0.4633, 0.0015, 0.4756], [0.0125, 0.6142, 0.0854, 0.7777, 0.218, 0.9616], ["L", 0.2203, 0.9647], [0.2207, 0.9653, 0.2204, 0.9652, 0.2221, 0.9655], [0.4049, 1.0, 0.5876, 1.0, 0.7703, 0.9655], [0.7703, 0.9655, 0.7704, 0.9655, 0.7704, 0.9655], [0.7721, 0.9652, 0.7718, 0.9653, 0.7722, 0.9647], ["L", 0.7744, 0.9616], [0.9071, 0.7777, 0.98, 0.6142, 0.9911, 0.4756], [1.0, 0.3625, 0.9681, 0.2653, 0.8962, 0.1864]]};
  /* ⚠ YATAY SÖRF = SİLÜETİN 90° DÖNDÜRÜLMÜŞÜ, GERİLMİŞİ DEĞİL (Ali 2026-10-07).
     Dikey vektörü yatay kutuya esnetmek burnu küt, kuyruğu şişkin bir şekil
     verirdi; sörf tahtası o değil. Nokta (u,v) saat yönünde dönüyor:
     (u,v) → (v, 1−u). Determinant +1, yani ÖZ DÖNME — ayna değil, tahta ters
     yüz olmuyor; burun sola bakıyor.
     ⚠ Yön KUTUDAN okunuyor (w > h); ayrı bir `shape` değeri eklenmedi, böylece
     maske/kenarlık çağrılarının hiçbiri değişmiyor. Kontrol noktaları da aynı
     dönüşümden geçer — afin dönüşüm Bézier'i bozmaz. */

  /* ⚠ HAM VEKTÖR [0,1] KUTUSUNA TAM OTURMUYOR (Ali 2026-10-07: "en sağ tarafı
     tam kenara yaslı değil"). Ölçüldü: u 0..0,9926 · v 0..0,9914 — sağda %0,74,
     altta %0,86 boşluk. Dikeyde boşluk ALTTA kalıp göze çarpmıyordu; 90°
     döndürünce SAĞ KENARA geçti ve hemen görüldü. Hata yeni değil, görünür oldu.
     Sınır kutusunu yüklenirken ÖLÇÜP [0,1]'e eşliyoruz: ham veri değişirse
     düzeltme kendiliğinden doğru kalır, elle düzeltilmiş sayılar bayatlardı. */
  var SURF_KUTU = (function () {
    var xs = [], ys = [];
    function ekle(x, y) { xs.push(x); ys.push(y); }
    function egri(p0, p1, p2, p3) {
      for (var i = 0; i <= 24; i++) {
        var t = i / 24, m = 1 - t;
        ekle(m * m * m * p0[0] + 3 * m * m * t * p1[0] + 3 * m * t * t * p2[0] + t * t * t * p3[0],
             m * m * m * p0[1] + 3 * m * m * t * p1[1] + 3 * m * t * t * p2[1] + t * t * t * p3[1]);
      }
    }
    var o = SURF_EXACT.start;
    ekle(o[0], o[1]);
    SURF_EXACT.curves.forEach(function (c) {
      if (c[0] === 'L') { o = [c[1], c[2]]; ekle(o[0], o[1]); }
      else { egri(o, [c[0], c[1]], [c[2], c[3]], [c[4], c[5]]); o = [c[4], c[5]]; }
    });
    var x0 = Math.min.apply(null, xs), x1 = Math.max.apply(null, xs);
    var y0 = Math.min.apply(null, ys), y1 = Math.max.apply(null, ys);
    return { x0: x0, y0: y0, sx: 1 / (x1 - x0), sy: 1 / (y1 - y0) };
  })();
  function surfN(u, v) {
    return [(u - SURF_KUTU.x0) * SURF_KUTU.sx, (v - SURF_KUTU.y0) * SURF_KUTU.sy];
  }
  function surfPathD(x, y, w, h) {
    var yatay = w > h;
    function X(u, v) { var n = surfN(u, v); return (x + (yatay ? n[1] : n[0]) * w).toFixed(2); }
    function Y(u, v) { var n = surfN(u, v); return (y + (yatay ? 1 - n[0] : n[1]) * h).toFixed(2); }
    var s0 = SURF_EXACT.start;
    var d = 'M ' + X(s0[0], s0[1]) + ' ' + Y(s0[0], s0[1]);
    SURF_EXACT.curves.forEach(function (s) {
      if (s[0] === 'L') d += ' L ' + X(s[1], s[2]) + ' ' + Y(s[1], s[2]);
      else d += ' C ' + X(s[0], s[1]) + ' ' + Y(s[0], s[1]) +
                 ' ' + X(s[2], s[3]) + ' ' + Y(s[2], s[3]) +
                 ' ' + X(s[4], s[5]) + ' ' + Y(s[4], s[5]);
    });
    return d + ' Z';
  }
  /* Studio Light canvas paleti */
  var C = {
    mask: 'rgba(250,249,247,0.86)', border: 'rgba(22,21,26,.45)',
    tick: '#0D9488', handle: '#0D9488', handleStroke: '#ffffff',
    labelFill: '#ffffff', labelStroke: 'rgba(13,148,136,.45)', labelText: '#16151a',
  };

  var stageEl = document.getElementById('ip-stage');
  var canvas = new fabric.Canvas('ip-canvas', {
    backgroundColor: 'transparent', preserveObjectStacking: true, selection: false,
  });

  var state = {
    step: 1, fmtIdx: 0, size: FORMATS[0].sizes[0], material: 'glass',
    frame: null, img: null, decor: [], gaps: [], upload: null, previewUrl: null,
    CW: 0, CH: 0,
  };
  function curFmt() { return FORMATS[state.fmtIdx]; }
  function curShape() { return { shape: curFmt().kind, name: curFmt().name }; }

  /* ── sahne / responsive ── */
  function layout() {
    var w = stageEl.clientWidth, h = stageEl.clientHeight;
    if (!w || !h) return;
    var pl = state.img ? placementGet() : null;
    state.CW = w; state.CH = h;
    canvas.setDimensions({ width: w, height: h });
    state.frame = computeFrame();
    buildDecor();
    if (state.img) { pl ? placementSet(pl) : fillFrame(); }
    canvas.requestRenderAll();
  }
  window.addEventListener('resize', debounce(layout, 120));

  function computeFrame() {
    var v = state.size;
    var pad = Math.max(26, Math.min(56, state.CW * 0.07));
    var padTop = pad + 50;   // ölçü etiketi çerçeveye/köşe braketine binmesin (Ali; 44→50, etiket ortalandı)
    var maxW = state.CW - pad * 2, maxH = state.CH - padTop - pad, ar = v.w / v.h;
    var fw = maxW, fh = fw / ar;
    if (fh > maxH) { fh = maxH; fw = fh * ar; }
    return { x: (state.CW - fw) / 2, y: padTop + (maxH - fh) / 2, w: fw, h: fh, shape: curShape().shape };
  }

  /* ── dekor ── */
  function buildDecor() {
    var fr = state.frame, v = state.size;
    state.decor.forEach(function (o) { canvas.remove(o); });
    state.decor = [];

    var d = 'M 0 0 L ' + state.CW + ' 0 L ' + state.CW + ' ' + state.CH + ' L 0 ' + state.CH + ' Z ';
    if (fr.shape === 'surf') {
      d += surfPathD(fr.x, fr.y, fr.w, fr.h);
    } else if (fr.shape === 'round') {
      var rx = fr.w / 2, ry = fr.h / 2, cx = fr.x + rx, cy = fr.y + ry;
      d += 'M ' + (cx - rx) + ' ' + cy + ' A ' + rx + ' ' + ry + ' 0 1 0 ' + (cx + rx) + ' ' + cy +
           ' A ' + rx + ' ' + ry + ' 0 1 0 ' + (cx - rx) + ' ' + cy + ' Z';
    } else {
      d += 'M ' + fr.x + ' ' + fr.y + ' L ' + (fr.x + fr.w) + ' ' + fr.y + ' L ' + (fr.x + fr.w) + ' ' + (fr.y + fr.h) +
           ' L ' + fr.x + ' ' + (fr.y + fr.h) + ' Z';
    }
    state.decor.push(new fabric.Path(d, { fill: C.mask, fillRule: 'evenodd',
      selectable: false, evented: false, objectCaching: false, hoverCursor: 'default' }));

    var border;
    if (fr.shape === 'surf') {
      border = new fabric.Path(surfPathD(fr.x, fr.y, fr.w, fr.h), { fill: '',
        stroke: C.border, strokeWidth: 1, selectable: false, evented: false, objectCaching: false });
    } else if (fr.shape === 'round') {
      border = new fabric.Ellipse({ left: fr.x, top: fr.y, rx: fr.w / 2, ry: fr.h / 2, fill: '',
        stroke: C.border, strokeWidth: 1, selectable: false, evented: false, objectCaching: false });
    } else {
      border = new fabric.Rect({ left: fr.x, top: fr.y, width: fr.w, height: fr.h, fill: '',
        stroke: C.border, strokeWidth: 1, selectable: false, evented: false, objectCaching: false });
    }
    state.decor.push(border);

    /* ADIM1_NOTR (Ali 2026-08-17): kose hizalama braketleri ancak ÖLÇÜ
       SECILDIKTEN sonra cizilir. 1. adimda cizilince "hizalama acildi,
       demek ki secim bitti" izlenimi veriyordu; oysa olcu/yon 2. adimda. */
    if (state.sizeChosen && fr.shape !== 'round' && fr.shape !== 'surf') {
      var L = Math.max(14, Math.min(22, fr.w * 0.06)), sw = 2.5;
      [
        'M ' + fr.x + ' ' + (fr.y + L) + ' L ' + fr.x + ' ' + fr.y + ' L ' + (fr.x + L) + ' ' + fr.y,
        'M ' + (fr.x + fr.w - L) + ' ' + fr.y + ' L ' + (fr.x + fr.w) + ' ' + fr.y + ' L ' + (fr.x + fr.w) + ' ' + (fr.y + L),
        'M ' + (fr.x + fr.w) + ' ' + (fr.y + fr.h - L) + ' L ' + (fr.x + fr.w) + ' ' + (fr.y + fr.h) + ' L ' + (fr.x + fr.w - L) + ' ' + (fr.y + fr.h),
        'M ' + (fr.x + L) + ' ' + (fr.y + fr.h) + ' L ' + fr.x + ' ' + (fr.y + fr.h) + ' L ' + fr.x + ' ' + (fr.y + fr.h - L),
      ].forEach(function (p) {
        state.decor.push(new fabric.Path(p, { fill: '', stroke: C.tick, strokeWidth: sw,
          strokeLineCap: 'round', strokeLineJoin: 'round', selectable: false, evented: false, objectCaching: false }));
      });
    }

    /* ADIM1_NOTR: etiket ("12\"x8\" · Landscape") ancak ÖLÇÜ SECILINCE
       basilir. Kanvasta tek "Rectangular" karosu icerde sessizce `rl` seciyor
       (renderFormats `rp`yi hic cizmiyor) -> etiket YATAY diye ilan ediyordu ama
       kullanici yonu daha secmemisti. Secim mantigina DOKUNULMADI, yalniz
       gorunum `state.sizeChosen` kapisina baglandi. */
    if (state.sizeChosen) {
    var txt = new fabric.Text('  ' + v.label + '  ·  ' + curShape().name + '  ', {
      fontSize: 11.5, fontFamily: 'Plus Jakarta Sans, Arial', fill: C.labelText,
      selectable: false, evented: false });
    var pill = new fabric.Rect({ width: txt.width + 6, height: 23, rx: 11.5, ry: 11.5,
      fill: C.labelFill, stroke: C.labelStroke, strokeWidth: 1, selectable: false, evented: false });
    /* ⚠ Etiket konumu (Ali iki kez bildirdi):
       1) 2026-07-30 — köşe braketiyle AYNI x'te başlıyordu, yapışık duruyordu.
       2) 2026-07-31 — sola dayalı olduğu için hâlâ çerçeveye yapışık görünüyordu.
       ÇÖZÜM: etiket çerçevenin ÜSTÜNDE YATAY ORTALANIR (sol köşeyle hizalanmaz) ve
       dikey boşluk artırılır. Genişlik pill.width üzerinden hesaplanır ki her ölçü
       yazısında (kısa/uzun) ortada kalsın. */
    /* ⚠ Yazı kapsülün İÇİNDE üste yapışıyordu (Ali 2026-07-31): fabric grup içindeki
       nesneleri kendi left/top'una göre yerleştirir, ikisi de 0 olduğu için metin
       kapsülün ÜST kenarına hizalanıyordu. Metni kapsülün içinde iki eksende de
       ortalıyoruz (yükseklik farkının yarısı kadar aşağı, genişlik farkının yarısı sağa). */
    var pillW = txt.width + 6, pillH = 23;
    pill.set({ left: 0, top: 0, originX: 'left', originY: 'top' });
    /* fabric'in KANONİK ortalaması: metnin kendi origin'ini merkeze alıp kapsülün
       merkezine oturt. (Önce left/top hesabı denendi, grup yerleşimi sırasında
       ezildi — piksel ölçümü üstte 2px / altta 11px gösterdi.) */
    txt.set({ originX: 'center', originY: 'center', left: pillW / 2, top: pillH / 2 });
    state.decor.push(new fabric.Group([pill, txt], {
      left: fr.x + (fr.w - pillW) / 2, top: fr.y - 46,
      selectable: false, evented: false, objectCaching: false }));
    }

    canvas.add.apply(canvas, state.decor);
    buildGaps();
    liftDecor();
  }

  /* çok-parçalı: panel araları — kağıt renginde boşluk bandı (basılmaz) + ince kenar.
     ÖNİZLEMEDE görünür kalır (decor'dan ayrı katman) ki müşteri panel bölünmesini görsün. */
  function panelLayout(fr) {
    var p = curFmt().panels; if (!p) return null;
    var gpx = (p.gap_mm / state.size.w) * fr.w;          // boşluk px (toplam mm ölçeği)
    var out = { gap: gpx, cells: [], vlines: [], hlines: [] };
    if (p.layout === 'row') {
      var pw = (fr.w - (p.count - 1) * gpx) / p.count;
      for (var i = 0; i < p.count; i++) {
        var x = fr.x + i * (pw + gpx);
        out.cells.push({ x: x, y: fr.y, w: pw, h: fr.h });
        if (i > 0) out.vlines.push(x - gpx);
      }
    } else {                                              // grid cols×rows
      var gpyRatio = (p.gap_mm / state.size.h) * fr.h;
      var cw = (fr.w - (p.cols - 1) * gpx) / p.cols;
      var ch = (fr.h - (p.rows - 1) * gpyRatio) / p.rows;
      for (var r = 0; r < p.rows; r++) for (var c = 0; c < p.cols; c++) {
        var cx = fr.x + c * (cw + gpx), cy = fr.y + r * (ch + gpyRatio);
        out.cells.push({ x: cx, y: cy, w: cw, h: ch });
        if (c > 0 && r === 0) out.vlines.push(cx - gpx);
        if (r > 0 && c === 0) out.hlines.push(cy - gpyRatio);
      }
      out.gapY = gpyRatio;
    }
    return out;
  }
  function buildGaps() {
    state.gaps.forEach(function (o) { canvas.remove(o); });
    state.gaps = [];
    if (curFmt().kind !== 'multi') return;
    var fr = state.frame, L = panelLayout(fr);
    L.vlines.forEach(function (x) {
      state.gaps.push(new fabric.Rect({ left: x, top: fr.y, width: L.gap, height: fr.h,
        fill: C.mask, selectable: false, evented: false, objectCaching: false }));
    });
    (L.hlines || []).forEach(function (y) {
      state.gaps.push(new fabric.Rect({ left: fr.x, top: y, width: fr.w, height: L.gapY,
        fill: C.mask, selectable: false, evented: false, objectCaching: false }));
    });
    L.cells.forEach(function (c) {
      state.gaps.push(new fabric.Rect({ left: c.x, top: c.y, width: c.w, height: c.h, fill: '',
        stroke: C.tick, strokeWidth: 1.5, selectable: false, evented: false, objectCaching: false }));
    });
    canvas.add.apply(canvas, state.gaps);
  }
  function liftDecor() {
    state.decor.forEach(function (o) { canvas.bringToFront(o); });
    state.gaps.forEach(function (o) { canvas.bringToFront(o); });
  }

  /* ── kısıt ── */
  function coverScale(fr, img) {
    var ang = ((img.angle % 360) + 360) % 360, rot = (ang === 90 || ang === 270);
    var iw = rot ? img.__nat.h : img.__nat.w, ih = rot ? img.__nat.w : img.__nat.h;
    return Math.max(fr.w / iw, fr.h / ih);
  }
  function constrain() {
    var img = state.img, fr = state.frame; if (!img) return;
    var min = coverScale(fr, img);
    if (img.scaleX < min - 1e-4 || img.scaleY < min - 1e-4) { img.scaleX = img.scaleY = min; }
    else { img.scaleY = img.scaleX; }
    var ang = ((img.angle % 360) + 360) % 360, rot = (ang === 90 || ang === 270);
    var EW = (rot ? img.__nat.h : img.__nat.w) * img.scaleX;
    var EH = (rot ? img.__nat.w : img.__nat.h) * img.scaleY;
    img.left = Math.min(fr.x + EW / 2, Math.max(fr.x + fr.w - EW / 2, img.left));
    img.top  = Math.min(fr.y + EH / 2, Math.max(fr.y + fr.h - EH / 2, img.top));
    img.setCoords();
  }
  function fillFrame() {
    var img = state.img, fr = state.frame; if (!img) return;
    img.scaleX = img.scaleY = coverScale(fr, img);
    img.left = fr.x + fr.w / 2; img.top = fr.y + fr.h / 2;
    constrain(); liftDecor(); canvas.requestRenderAll(); syncZoom();
  }

  function placementGet() {
    var img = state.img, fr = state.frame;
    var ang = ((img.angle % 360) + 360) % 360, rot = (ang === 90 || ang === 270);
    var effW = (rot ? img.__nat.h : img.__nat.w) * img.scaleX;
    return { cx: (img.left - fr.x) / fr.w, cy: (img.top - fr.y) / fr.h,
             scale: effW / fr.w, angle: img.angle || 0, flip_x: !!img.flipX };
  }
  function placementSet(pl) {
    var img = state.img, fr = state.frame;
    img.angle = pl.angle || 0; img.flipX = !!pl.flip_x;
    var ang = ((img.angle % 360) + 360) % 360, rot = (ang === 90 || ang === 270);
    var natW = rot ? img.__nat.h : img.__nat.w;
    img.scaleX = img.scaleY = (pl.scale * fr.w) / natW;
    img.left = fr.x + pl.cx * fr.w; img.top = fr.y + pl.cy * fr.h;
    constrain(); liftDecor(); canvas.requestRenderAll(); syncZoom();
  }

  /* ── yükleme ── */
  /* ── İKİ FAZLI YÜKLEME (Ali 2026-07-30) ───────────────────────────────
     ÖLÇÜLDÜ: yükleme süresi dosya boyutuyla neredeyse doğrusal → darboğaz müşterinin
     bant genişliği (18.7MB = 26.5 sn). Oysa editör, kırpma, önizleme ve 3B için
     küçük bir kopya YETİYOR; orijinale SADECE baskı dosyası üretilirken ihtiyaç var.
     Bu yüzden: (1) tarayıcıda ~2400px'e küçült, onu gönder → editör anında açılır;
     (2) ORİJİNALİ müşteri önizleme adımına geçince (=niyet belli) arka planda gönder.
     Fotoğraf seçip vazgeçenler için orijinal HİÇ yüklenmez → boşuna bant ve depolama yok. */
  var MAX_EDGE = 2400;
  var origFile = null, origState = 'none';   // none | uploading | done | failed

  function shrink(f, cb) {
    /* Tarayıcıda küçült. Tarayıcı EXIF yönünü çizerken uygular → çıktı düzgün döner.
       HEIC gibi tarayıcının açamadığı formatlarda başarısız olur; o zaman dosyanın
       TAMAMI gönderilir (sunucu pillow-heif ile açar) — akış asla kırılmaz. */
    try {
      var url = URL.createObjectURL(f);
      var im = new Image();
      im.onload = function () {
        try {
          var s = Math.min(1, MAX_EDGE / Math.max(im.naturalWidth, im.naturalHeight));
          var c = document.createElement('canvas');
          c.width = Math.round(im.naturalWidth * s);
          c.height = Math.round(im.naturalHeight * s);
          c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
          c.toBlob(function (b) {
            URL.revokeObjectURL(url);
            if (b) cb(b, im.naturalWidth, im.naturalHeight); else cb(null);
          }, 'image/jpeg', 0.9);
        } catch (e) { URL.revokeObjectURL(url); cb(null); }
      };
      im.onerror = function () { URL.revokeObjectURL(url); cb(null); };
      im.src = url;
    } catch (e) { cb(null); }
  }

  function send(blob, name, stage, nw, nh) {
    var fd = new FormData();
    fd.append('file', blob, name);
    fd.append('stage', stage);
    if (nw) { fd.append('nat_w', nw); fd.append('nat_h', nh); }
    return fetch(API + '/upload', { method: 'POST', body: fd })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.detail || r.status); });
        return r.json();
      });
  }

  /* YUKLEME_KILIDI (Ali 2026-08-17): yukleme surerken tekrar tiklama korumasi.
     Eskiden `uploadFile` yeniden girise karsi korumasizdi -> iki send() + iki
     loadImage() yarisiyordu; buyuk dosyada hangisi once biterse tuvale o oturuyordu.
     Ayrica `busy(true)` yalniz SAHNEYE katman koyuyor, butonlar tiklanabilir kaliyordu. */
  var _ipYukleniyor = false, _ipKilitZaman = null;
  function ipYuklemeKilit(on) {
    _ipYukleniyor = on;
    ['ip-btn-cam', 'ip-btn-lib'].forEach(function (id) {
      var b = document.getElementById(id);
      if (!b) return;
      b.disabled = on;
      b.classList.toggle('ip-yukleniyor', on);
      b.setAttribute('aria-busy', on ? 'true' : 'false');
    });
    document.querySelectorAll('.ip-tool[data-act="replace"]').forEach(function (b) {
      b.disabled = on; b.classList.toggle('ip-yukleniyor', on);
    });
    clearTimeout(_ipKilitZaman);
    /* GUVENLIK: shrink()/agi geri cagirmazsa arayuz sonsuza dek kilitli kalmasin. */
    if (on) _ipKilitZaman = setTimeout(function () { ipYuklemeKilit(false); busy(false); }, 90000);
  }
  function uploadFile(f) {
    if (!f) return;
    if (_ipYukleniyor) {
      toast(IPT('ipj_upload_busy', 'Your photo is still uploading — one moment…'));
      return;
    }
    ipYuklemeKilit(true);
    busy(true);
    origFile = f; origState = 'none';
    shrink(f, function (blob, nw, nh) {
      var p = blob
        ? send(blob, (f.name || 'photo') + '.jpg', 'preview', nw, nh)
        : send(f, f.name || 'photo.jpg', 'full');     // HEIC vb. → tamamı gitsin
      p.then(function (j) { state.upload = j; loadImage(API + j.preview_url); })
       .catch(function (e) { ipYuklemeKilit(false); busy(false); toast('Upload failed: ' + e.message); });
    });
  }

  /* Orijinali arka planda gönder — müşteri önizleme adımına geçince. */
  function sendOriginal() {
    if (origState === 'uploading' || origState === 'done') return;
    if (!state.upload || !state.upload.needs_original) { origState = 'done'; return; }
    if (!origFile) { origState = 'failed'; return; }   // yenilemeden sonra dosya elimizde yok
    origState = 'uploading';
    var fd = new FormData();
    fd.append('file', origFile, origFile.name || 'original.jpg');
    fetch(API + '/upload/' + state.upload.upload_id + '/original', { method: 'POST', body: fd })
      .then(function (r) { origState = r.ok ? 'done' : 'failed'; })
      .catch(function () { origState = 'failed'; });
  }
  function loadImage(url, placement, onFail) {
    fabric.Image.fromURL(url, function (img) {
      busy(false);
      ipYuklemeKilit(false);   /* YUKLEME_KILIDI: basari yolu */
      if (!img || !img.width) {
        if (onFail) { onFail(); return; }
        toast(IPT('ipj_open_fail','Could not open image')); return;
      }
      if (state.img) canvas.remove(state.img);
      img.__nat = { w: img.width, h: img.height };
      img.set({ originX: 'center', originY: 'center',
        cornerColor: C.handle, cornerStrokeColor: C.handleStroke, cornerSize: 12,
        transparentCorners: false, borderColor: C.tick, borderScaleFactor: 1.4,
        lockScalingFlip: true });
      img.setControlsVisibility({ mtr: false, ml: false, mr: false, mt: false, mb: false });
      state.img = img;
      canvas.add(img);
      if (placement) { placementSet(placement); } else { fillFrame(); }
      canvas.setActiveObject(img);
    /* ADIM1_KILIT: oturum geri yuklendiginde ya da 1. adimdayken yuklenen gorsel
       de KILITLI baslar; yoksa setActiveObject tutamaklari hemen aciyordu. */
    if (state.step < 2) {
      img.set({ selectable: false, evented: false });
      try { canvas.discardActiveObject(); } catch (_e) {}
    }
      document.getElementById('ip-empty').style.display = 'none';
      document.getElementById('ip-upload-grid').hidden = true;
      document.getElementById('ip-place').hidden = false;
      updateBar();
      saveSession();
      /* ⚠ KANVAS HATASI (Ali 2026-08-01): kanvasta ölçüden ÖNCE bir YÖN seçici var
         (#ip-orient). Doğrudan ölçüye kaydırınca yön bloğu YAPIŞKAN KARTIN ALTINDA
         kalıyordu (ölçüm: yön 230..349, kart 58..381 → tamamen gizli) ve müşteri
         yön seçeneğini hiç görmüyordu. Görünürse önce ona kaydır. */
      ipKaydir(ipIlkKontrol(), 420);
    }, { crossOrigin: 'anonymous' });
  }

  /* ── OTURUM HATIRLAMA (localStorage) ──────────────────────────────────
     Ali: müşteri sayfayı yenilerse ya da başka ürüne gidip dönerse fotoğrafını
     BAŞTAN yüklemek zorunda kalmasın.
     Ek maliyet YOK: görselin kendisi zaten sunucuda (R2 `tmp/`, 7 gün saklanıyor);
     burada yalnız birkaç yüz baytlık künye tutuyoruz (upload_id + yerleşim + seçimler).
     Görsel verisi localStorage'a KOYULMAZ (kota dolar, yavaşlatır).
     Dosya süresi dolmuş/silinmişse sessizce temiz başlanır — akış asla kilitlenmez. */
  var LS_KEY = 'ip_session_v1';
  var LS_TTL = 7 * 24 * 3600 * 1000;              // R2 tmp saklama süresiyle aynı

  function saveSession() {
    try {
      if (!state.upload || !state.img) return;
      localStorage.setItem(LS_KEY, JSON.stringify({
        t: Date.now(), up: state.upload, orig: origState,
        fmt: curFmt().id, size: state.size.id, mat: state.material,
        pl: placementGet(),
      }));
    } catch (e) { /* gizli mod / kota dolu → vazgeç, akışı BOZMA */ }
  }
  function clearSession() { try { localStorage.removeItem(LS_KEY); } catch (e) {} }

  function restoreSession() {
    var d = null;
    try { d = JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) { return; }
    if (!d || !d.up || !d.up.upload_id || !d.up.preview_url) return;
    if (Date.now() - (d.t || 0) > LS_TTL) { clearSession(); return; }

    // seçimleri geri yükle (format → malzeme uygunluğu → ölçü sırası önemli)
    var fi = -1;
    FORMATS.forEach(function (f, i) { if (f.id === d.fmt) fi = i; });
    if (fi >= 0) state.fmtIdx = fi;
    if (MATERIALS[d.mat] && sizesFor(d.mat, curFmt().id)) state.material = d.mat;
    document.querySelectorAll('.ip-mat').forEach(function (m) {
      m.classList.toggle('active', state.matChosen && m.dataset.mat === state.material);
    });
    renderFormats(); syncMaterialAvail(); renderStrip();
    var list = sizesFor(state.material, curFmt().id) || [];
    var sz = null;
    list.forEach(function (s) { if (s.id === d.size) sz = s; });
    setSize(sz || list[0], false);

    state.upload = d.up;
    if (d.orig === 'done') { origState = 'done'; state.upload.needs_original = false; }
    busy(true);
    loadImage(API + d.up.preview_url, d.pl, function () {
      clearSession();                              // dosya artık yok → temiz başla
      state.upload = null;
      toast(IPT('ipj_expired','Your previous photo is no longer available — please upload it again'));
    });
    go(2);
  }

  /* ── şekil / ölçü / fiyat ── */
  /* ⚠ PARA BİRİMİ (Ali 2026-08-04): eskiden '$' SABİTTİ ve tutarlar USD'ydi.
     Artık biçim mağazanın presentment biçimi, tutar da mümkünse Shopify'ın
     gerçek varyant fiyatı (IP_PRICES) — ekranda yazan = kasada ödenecek. */
  function money(n) {                      // n ZATEN müşterinin para biriminde
    if (window.InsMoney) return window.InsMoney.fmt(n);
    var k = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    return (k ? k + ' ' : '') + Number(n).toFixed(2);
  }
  function moneyUsd(n) {                   // n USD → çevir + biçimle
    if (window.InsMoney) return window.InsMoney.usd(n);
    var k = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    return (k ? k + ' ' : '') + Number(n).toFixed(2);
  }
  /* Bir ölçü nesnesinin müşteri para birimindeki fiyatı (ana birim). */
  function pFiyat(v, alan) {
    var usd = (alan === 'was') ? v.was : v.price;
    try {
      var vid = VMAP && VMAP.variants[state.material + '|' + curFmt().id + '|' + v.id];
      var pr = vid && window.IP_PRICES && window.IP_PRICES[String(vid)];
      if (pr) { var c = (alan === 'was') ? pr[1] : pr[0]; if (c) return c / 100; }
    } catch (e) {}
    return (Number(usd) || 0) * (window.InsMoney ? window.InsMoney.kur : 1);
  }
  function renderPrice() {
    var v = state.size, was = document.getElementById('ip-was'), save = document.getElementById('ip-save');
    if (state.step === 1) {
      // ölçü henüz seçilmedi → formatın başlangıç fiyatı
      var min = Infinity;
      (sizesFor(state.material, curFmt().id) || []).forEach(function (s) { if (s.price < min) min = s.price; });
      document.getElementById('ip-price').textContent = IPT('ipj_from', 'From ') + moneyUsd(min);
      was.hidden = true; save.hidden = true;
      return;
    }
    var _p = pFiyat(v, 'price'), _w = pFiyat(v, 'was');
    document.getElementById('ip-price').textContent = money(_p);
    was.textContent = money(_w); was.hidden = !(_w > _p);
    save.textContent = IPT('ipj_save', 'SAVE ') + money(_w - _p); save.hidden = !(_w > _p);
  }
  function setFormat(idx) {
    state.fmtChosen = true;
    if (state.fmtIdx === idx) { renderFormats(); updateBar(); return; }
    state.fmtIdx = idx;
    state.sizeChosen = false;      // format değişti → ölçü yeniden seçilmeli
    syncMaterialAvail();
    setSize(sizesFor(state.material, curFmt().id)[0], false);
    if (state.img) document.getElementById('ip-orient-tip').hidden = false;
    /* ⚠ format degisince YON SECICI yeniden cizilmeliydi: KARE secilince eski hali
       ekranda kaliyordu (renderOrient yalniz rl/rp'de gosterir ama cagrilmiyordu). */
    renderFormats(); renderOrient(); saveSession();
  }
  /* format için ölçüsü OLMAYAN malzeme gizlenir (Round→yalnız cam; alu→yalnız kare; vb.) */
  function syncMaterialAvail() {
    var fid = curFmt().id;
    /* MALZEME_KALICI (Ali 2026-08-17): MALZEME ARTIK GIZLENMEZ.
       Eskiden `m.hidden = !sizesFor(...)` idi: Surfboard (yalniz cam) secilince
       kanvas/aluminyum kayboluyordu ve kullanici malzemeyi degistirmek icin once
       sekli degistirmek zorunda kaliyordu — cikmaz sokak. Malzemeye tiklaninca
       sekil secimi zaten sifirlaniyor ve o malzemenin sekilleri listeleniyor. */
    document.querySelectorAll('.ip-mat').forEach(function (m) {
      m.hidden = false;
    });
    if (!sizesFor(state.material, fid)) {
      state.material = 'glass'; renderStrip();
      document.querySelectorAll('.ip-mat').forEach(function (m) {
        m.classList.toggle('active', m.dataset.mat === 'glass');
      });
    }
  }
  /* malzeme değişince ölçüyü yeni listeye eşle (aynı etiket varsa koru) */
  function remapSize() {
    var list = sizesFor(state.material, curFmt().id) || [];
    var keep = null;
    list.forEach(function (s) { if (s.label === state.size.label) keep = s; });
    setSize(keep || list[0], false);
  }
  function setSize(v, isUser) {
    var prev = state.size;
    if (isUser) state.sizeChosen = true;
    state.size = v;
    state.frame = computeFrame();
    buildDecor();
    if (state.img) fillFrame(); // aynı format içinde oran ~aynı → uyarı yok (uyarı setFormat'ta)
    renderChips(); renderPrice(); updateBar(); saveSession();
  }
  function orientFree() { return !!MATERIALS[state.material].orientFree; }
  function renderFormats() {
    var box = document.getElementById('ip-formats'); box.innerHTML = '';
    var oFree = orientFree();
    FORMATS.forEach(function (f, i) {
      if (!sizesFor(state.material, f.id)) return;        // bu malzemede yok → hiç gösterme
      if (oFree && f.id === 'rp') return;                 // dikey, yatayla AYNI karonun altında
      var b = document.createElement('button');
      var act = (i === state.fmtIdx) || (oFree && f.id === 'rl' && curFmt().id === 'rp');
      b.className = 'ip-fmt' + (act && state.fmtChosen ? ' active' : '');   // ön-seçim gösterme (Ali)
      // estetik mini-çerçeve: gerçek oranla CSS kutusu (yuvarlakta daire, surfta gerçek siluet)
      var frameHtml;
      if (f.kind === 'surf') {
        var act = i === state.fmtIdx;
        var g0 = act ? '#bfe3df' : '#cfe7e4', g1 = act ? '#0D9488' : '#8fc7c1', g2 = act ? '#0891B2' : '#5aa8a1';
        var stk = act ? 'var(--crimson)' : 'rgba(22,21,26,.4)';
        /* ⚠ KÜÇÜK GÖRSEL DE DÖNER (Ali: "görselini de yataya göre yapmalıyız").
           viewBox ve çizim kutusu formatın oranını izler; aksi hâlde yatay
           seçeneğin kartında dikey tahta görünür ve kartla ürün ayrışırdı —
           bu mağazada daha önce yaşanmış bir hata. */
        var yat = f.ar >= 1;
        var vb = yat ? '0 0 100 34' : '0 0 34 100';
        var bw = yat ? 96.8 : 30.8, bh = yat ? 30.8 : 96.8;
        var olcu = yat ? 'width:86%' : 'height:80%';
        frameHtml = '<svg class="ip-fmt-frame ip-fmt-frame--surf" viewBox="' + vb + '" style="' + olcu + '">' +
          '<defs><linearGradient id="ipSurfG" x1="0" y1="0" x2="1" y2="1">' +
          '<stop offset="0" stop-color="' + g0 + '"/><stop offset="0.55" stop-color="' + g1 + '"/>' +
          '<stop offset="1" stop-color="' + g2 + '"/></linearGradient></defs>' +
          '<path d="' + surfPathD(1.6, 1.6, bw, bh) + '" fill="url(#ipSurfG)" stroke="' + stk + '" stroke-width="1.4"/></svg>';
      } else if (f.kind === 'multi') {
        var p = f.panels, cells = '';
        var wStyle = f.ar >= 1 ? 'width:66%' : 'height:74%';
        if (p.layout === 'row') {
          for (var pi = 0; pi < p.count; pi++) cells += '<span class="ip-fmt-panel"></span>';
          frameHtml = '<span class="ip-fmt-frame ip-fmt-frame--multi" style="aspect-ratio:' + f.ar.toFixed(3) + ';' + wStyle + '">' + cells + '</span>';
        } else {
          for (var gi = 0; gi < p.cols * p.rows; gi++) cells += '<span class="ip-fmt-panel"></span>';
          frameHtml = '<span class="ip-fmt-frame ip-fmt-frame--grid" style="aspect-ratio:1;' + wStyle + ';grid-template-columns:repeat(' + p.cols + ',1fr)">' + cells + '</span>';
        }
      } else if (oFree && f.id === 'rl') {
        /* ADIM1_KILIT_IKON: kanvasta yon SONRAKI adimda seciliyor ve `rp` karosu hic
           cizilmiyor; tek yatay dikdortgen "sadece yatay var" izlenimi veriyordu
           (Ali 2026-08-17). Ikon iki yonu birden gosterir. Cam/aluminyumda Landscape
           ve Portrait AYRI karolar oldugu icin oralarda tek yonlu ikon DOGRU. */
        frameHtml = '<span class="ip-fmt-duo">' +
          '<span class="ip-fmt-frame" style="aspect-ratio:1.58;width:54%"></span>' +
          '<span class="ip-fmt-frame" style="aspect-ratio:0.633;height:64%"></span>' +
          '</span>';
      } else {
        var arShow = (oFree && f.id === 'rl' && curFmt().id === 'rp') ? (1 / f.ar) : f.ar;
        var frameStyle = 'aspect-ratio:' + arShow.toFixed(3) +
          (f.kind === 'round' ? ';border-radius:50%' : '') +
          (arShow >= 1 ? ';width:64%' : ';height:74%');
        frameHtml = '<span class="ip-fmt-frame" style="' + frameStyle + '"></span>';
      }
      // ⚠ eskiden HER ZAMAN camın ölçü sayısını yazıyordu (kanvasta 11 varken "4 sizes")
      var lst = sizesFor(state.material, f.id) || f.sizes;
      var nm = (oFree && f.id === 'rl') ? IPT('ipj_p_rect', 'Rectangular') : f.name;
      b.innerHTML =
        '<span class="ip-fmt-stage">' + frameHtml + '</span>' +
        '<b>' + nm + '</b><small>' + (lst.length > 1 ? IPT('ipj_sizes_many','{n} sizes').replace('{n}', lst.length) : lst[0].label) + '</small>';
      b.onclick = function () {
        // birleşik karo: hâlihazırda dikeydeysek dikeyde kal, değilse yataya geç
        if (oFree && f.id === 'rl' && curFmt().id === 'rp') {
          /* MALZEME_KALICI_RECT: eskiden burada SADECE renderFormats() cagrilip
             cikiliyordu; `state.fmtChosen` hic isaretlenmedigi icin karo aktiflesmiyor
             ve Continue kapali kaliyordu. Kullanici once Square'a, sonra tekrar
             Rectangular'a basinca duzeliyordu (Ali 2026-08-17 tarif etti).
             Dikeyde kalma niyeti KORUNUR, ama secim artik ISARETLENIR. */
          state.fmtChosen = true;
          renderFormats(); renderChips(); renderOrient(); renderPrice();
          updateBar(); saveSession();
          return;
        }
        setFormat(i);
      };
      box.appendChild(b);
    });
  }
  function renderChips() {
    var box = document.getElementById('ip-variants'); box.innerHTML = '';
    (sizesFor(state.material, curFmt().id) || []).forEach(function (v) {
      var b = document.createElement('button');
      b.className = 'ip-chip' + (state.sizeChosen && v.id === state.size.id ? ' active' : '');   // ön-seçim gösterme (Ali)
      /* ÖLÇÜ BİRİMİ (Ali 2026-08-04): ABD inç, diğer tüm ülkeler cm.
         Etiket ile alt yazı yer değiştirir — ikisi birden ASLA gösterilmez. */
      var bas = olcuBas(v, curFmt());
      /* Tek birim: ABD'de inç, diğer ülkelerde cm — ikisi birden gösterilmez. */
      var sub = (orientFree() ? '' : curFmt().name);
      var pOl = parcaOlcu(v, curFmt());
      b.innerHTML = '<span class="ip-chip-t">' + bas + (pOl ? '<small>' + pOl + '</small>' : '') + '<small>' + sub + '</small></span>' +
        (v.pop ? '<span class="ip-chip-pop">★ ' + IPT('ipj_popular', 'Popular') + '</span>' : '') +
        '<span class="ip-chip-p">' + money(pFiyat(v, 'price')) + '</span>';
      b.onclick = function () { setSize(v, true); };
      box.appendChild(b);
    });
  }

  /* Yön seçici — yalnız yönün ürünü değiştirmediği malzemelerde (kanvas) görünür.
     Format ızgarasında iki karo yerine burada tek bir seçim; ölçüler buna göre gelir. */
  function renderOrient() {
    var box = document.getElementById('ip-orient');
    var show = orientFree() && (curFmt().id === 'rl' || curFmt().id === 'rp');
    box.hidden = !show;
    if (!show) return;
    box.querySelectorAll('.ip-ob').forEach(function (b) {
      b.classList.toggle('active', b.dataset.o === curFmt().id);
    });
  }
  function setOrient(id) {
    if (curFmt().id === id) return;
    var i = -1;
    FORMATS.forEach(function (f, k) { if (f.id === id) i = k; });
    if (i < 0 || !sizesFor(state.material, id)) return;
    setFormat(i);                       // oran değişir → görsel yeniden sığdırılır + uyarı
    renderOrient();
  }

  /* ── reçete ── */
  /* ⚠ Ali kuralı: dosya adındaki cm KATALOG değeridir, inç×2.54 çevirisi değil.
     Katalog cm'i ölçünün `sub` alanında (ör. "72×46 cm"); yoksa mm'den türetilir ve
     'derived' işaretlenir → panelde ayırt edilir, Ali gerçek değeri verince düzeltilir. */
  function sizeCm(v) {
    var m = (v.sub || '').match(/^(\d+(?:\.\d+)?)×(\d+(?:\.\d+)?)\s*cm/);
    if (m) return { cm: m[1] + 'x' + m[2], src: 'catalog' };
    var r = (v.sub || '').match(/^(\d+(?:\.\d+)?)\s*cm$/);          // yuvarlak: tek çap
    if (r) return { cm: r[1], src: 'catalog' };
    return { cm: Math.round(v.w / 10) + 'x' + Math.round(v.h / 10), src: 'derived' };
  }
  function buildRecipe() {
    var v = state.size, img = state.img, cm = sizeCm(v);
    return {
      version: 1,
      product_id: 'custom-print-on-glass',
      variant: { shape: curFmt().product, orientation: curFmt().name, size: v.label, shape_kind: curFmt().kind,
        size_cm: cm.cm, size_cm_source: cm.src, size_sub: v.sub || '',
        format_id: curFmt().id, size_id: v.id,
        material: MATERIALS[state.material].slug, price: v.price,
        print_w_mm: +v.w.toFixed(1), print_h_mm: +v.h.toFixed(1), dpi: DPI, bleed_mm: BLEED_MM,
        panels: curFmt().panels || null },
      layers: img ? [{ type: 'image',
        upload_id: state.upload ? state.upload.upload_id : '(local)',
        nat_w: state.upload ? state.upload.nat_w : img.__nat.w,
        nat_h: state.upload ? state.upload.nat_h : img.__nat.h,
        placement: placementGet() }] : [],
    };
  }

  function renderPrintResult(mult) {
    var fr = state.frame; if (!state.img) return null;
    state.decor.forEach(function (o) { o.set('visible', false); });
    // surf/round: şekil DIŞINI beyaz yap (baskı kesim şekli — dikdörtgen değil) → decor[0]=maske
    var shapeMask = (fr.shape === 'surf' || fr.shape === 'round') ? state.decor[0] : null;
    if (shapeMask) shapeMask.set({ visible: true, fill: '#ffffff' });
    // çok-parçalı: boşluk bantları önizlemede KALIR (panel bölünmesi görünsün); opak beyaz yap
    var gapFills = state.gaps.filter(function (o) { return o.width && o.fill; });
    gapFills.forEach(function (o) { o.set('fill', '#ffffff'); });
    var act = canvas.getActiveObject(); canvas.discardActiveObject();
    canvas.renderAll();
    var url = canvas.toDataURL({ left: fr.x, top: fr.y, width: fr.w, height: fr.h,
      format: 'jpeg', quality: 0.92, multiplier: mult || 2 });
    state.decor.forEach(function (o) { o.set('visible', true); });
    if (shapeMask) shapeMask.set('fill', C.mask);
    gapFills.forEach(function (o) { o.set('fill', C.mask); });
    if (act) canvas.setActiveObject(act);
    canvas.renderAll();
    return url;
  }

  /* ── kanvas sarım önizlemesi: 8cm pay + 4.5cm mirror + ham bant + TERS logo (backend ile birebir) ── */
  var CANVAS_MARGIN_MM = 80, CANVAS_MIRROR_MM = 45;
  var logoImg = null;
  function withLogo(cb) {
    if (logoImg) { cb(logoImg); return; }
    var im = new Image();
    // Temada logo Shopify CDN'inden gelir → crossOrigin ŞART, yoksa kanvas "taint" olur
    // ve toDataURL() (baskı önizlemesi + sarım) SecurityError verir.
    im.crossOrigin = 'anonymous';
    im.onload = function () { logoImg = im; cb(im); };
    im.onerror = function () { cb(null); };
    im.src = CFG.logo || 'assets/logo-dark.png';
  }
  function buildCanvasWrap(cb) {
    var art = new Image();
    art.onload = function () {
      var aw = art.width, ah = art.height;
      var pxmm = aw / state.size.w;
      var M = Math.round(CANVAS_MARGIN_MM * pxmm), MIR = Math.round(CANVAS_MIRROR_MM * pxmm);
      var W = aw + 2 * M, H = ah + 2 * M;
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var g = c.getContext('2d');
      g.fillStyle = '#ffffff'; g.fillRect(0, 0, W, H);
      g.drawImage(art, M, M);
      function mir(sx, sy, sw, sh, dx, dy, fx, fy) {   // aynalı şerit
        g.save();
        g.translate(dx + (fx ? sw : 0), dy + (fy ? sh : 0));
        g.scale(fx ? -1 : 1, fy ? -1 : 1);
        g.drawImage(art, sx, sy, sw, sh, 0, 0, sw, sh);
        g.restore();
      }
      mir(0, 0, MIR, ah, M - MIR, M, true, false);
      mir(aw - MIR, 0, MIR, ah, M + aw, M, true, false);
      mir(0, 0, aw, MIR, M, M - MIR, false, true);
      mir(0, ah - MIR, aw, MIR, M, M + ah, false, true);
      mir(0, 0, MIR, MIR, M - MIR, M - MIR, true, true);
      mir(aw - MIR, 0, MIR, MIR, M + aw, M - MIR, true, true);
      mir(0, ah - MIR, MIR, MIR, M - MIR, M + ah, true, true);
      mir(aw - MIR, ah - MIR, MIR, MIR, M + aw, M + ah, true, true);
      withLogo(function (lg) {
        if (lg) {                                     // üst ham bantta 180° ters logo
          var lw = Math.round(60 * pxmm), lh = Math.round(lg.height * lw / lg.width);
          var raw = M - MIR;
          if (lh > raw - 6) { lh = Math.max(8, raw - 6); lw = Math.round(lg.width * lh / lg.height); }
          g.save(); g.translate(W / 2, raw / 2); g.rotate(Math.PI);
          g.drawImage(lg, -lw / 2, -lh / 2, lw, lh); g.restore();
        }
        /* GÖRÜNÜR kanvas örgü dokusu — baskının üstüne işlenir (ışıktan bağımsız) */
        var step = Math.max(4, Math.round(1.1 * pxmm));   // iplik aralığı — önizleme çözünürlüğünde de GÖRÜNÜR
        g.globalAlpha = 0.26; g.globalCompositeOperation = 'multiply';
        g.strokeStyle = '#8d7f68'; g.lineWidth = 1;
        for (var yy = 0; yy < H; yy += step) { g.beginPath(); g.moveTo(0, yy); g.lineTo(W, yy); g.stroke(); }
        for (var xx = 0; xx < W; xx += step) { g.beginPath(); g.moveTo(xx, 0); g.lineTo(xx, H); g.stroke(); }
        g.globalCompositeOperation = 'overlay'; g.globalAlpha = 0.18; g.strokeStyle = '#ffffff';
        for (var y2 = Math.round(step / 2); y2 < H; y2 += step) { g.beginPath(); g.moveTo(0, y2); g.lineTo(W, y2); g.stroke(); }
        g.globalAlpha = 1; g.globalCompositeOperation = 'source-over';
        cb(c.toDataURL('image/jpeg', 0.9));
      });
    };
    art.src = state.previewUrl;
  }

  /* ── sihirbaz: 1 ölçü → 2 görsel → 3 önizleme ── */
  /* ═══ MOBİL AKIŞ (Ali 2026-07-31) ═══════════════════════════════════════════
     SORUN: telefonda önizleme y=71–476 arasında, format seçimi y=879, ölçü y=1052.
     Kullanıcı seçim yaparken YÜKLEDİĞİ FOTOĞRAFI GÖRMÜYORDU.
     ÇÖZÜM: (a) önizleme kartı mobilde yapışkan (CSS), (b) bir adım/işlem bitince
     ekran bir sonraki kontrole otomatik kayar — yapışkan önizlemenin hemen altına.
     Masaüstünde hiçbir şey değişmez (genişlik eşiği 750px). */
  function ipMobil() { return window.matchMedia('(max-width: 749px)').matches; }
  function ipYapiskanAlt() {
    var c = document.querySelector('.ip-stage-card');
    if (c && c.offsetParent !== null) {
      var r = c.getBoundingClientRect();
      if (r.height > 0) return Math.max(0, r.bottom);
    }
    /* ⚠ 3. ADIM: yapışkan önizleme GİZLİ olduğu için burası 0 dönüyordu ve hedef
       site başlığının ALTINDA kalıyordu — adım ekranın 114px üstünde açılıyor,
       başlık ve sekmeler görünmüyordu (Ali bildirdi). Kart yoksa SİTE BAŞLIĞININ
       altını referans al. */
    var h = document.querySelector('#cinematic-header, .cinematic-header, header');
    if (h) {
      var hr = h.getBoundingClientRect();
      if (hr.height > 0 && hr.top <= 0) return Math.max(0, hr.bottom);
      if (hr.height > 0) return Math.max(0, hr.height);
    }
    return 0;
  }
  /* 2. adımda fotoğraftan sonra gelen İLK kontrol: kanvasta YÖN seçici, diğerlerinde ÖLÇÜ. */
  function ipIlkKontrol() {
    var o = document.getElementById('ip-orient');
    if (o && !o.hidden && o.getBoundingClientRect().height > 0) return o;
    return document.getElementById('ip-variants');
  }

  function ipKaydir(el, gecikme) {
    if (!ipMobil() || !el) return;
    setTimeout(function () {
      try {
        if (el.hidden || !el.getBoundingClientRect().height) return;
        var hedef = el.getBoundingClientRect().top + window.scrollY - ipYapiskanAlt() - 14;
        window.scrollTo({ top: Math.max(0, hedef), behavior: 'smooth' });
      } catch (e) {}
    }, gecikme || 260);
  }

  /* ═══ ADIM KİLİDİ (Ali 2026-08-02) ═══════════════════════════════════════════
     Üstteki sekmelere (Format · Photo & Size · Preview) tıklayarak hiçbir seçim
     yapmadan 2. adıma geçilebiliyordu → malzeme/şekil seçilmeden devam ediliyordu.
     Kural: İLERİ gitmek için o adıma kadarki seçimler TAM olmalı; GERİ dönmek
     (düzeltmek için) her zaman serbest. */
  function adimIzinli(hedef) {
    if (hedef <= state.step) return true;              // geri/aynı adım: serbest
    if (hedef >= 2 && !(state.matChosen && state.fmtChosen)) return false;
    if (hedef >= 3 && !(state.img && state.sizeChosen)) return false;
    return true;
  }
  function adimUyari(hedef) {
    if (hedef >= 2 && !state.matChosen) return IPT('ipj_need_material','Choose a material to continue');
    if (hedef >= 2 && !state.fmtChosen) return IPT('ipj_need_format','Choose a shape to continue');
    if (hedef >= 3 && !state.img)       return IPT('ipj_need_photo','Add your photo to continue');
    if (hedef >= 3 && !state.sizeChosen) return IPT('ipj_need_size','Choose a size to continue');
    return '';
  }

  function go(step) {
    if (!adimIzinli(step)) { var u = adimUyari(step); if (u) toast(u); return; }
    if (step >= 3 && !state.img) { toast(IPT('ipj_photo_first','Add your photo first')); step = 2; }
    state.step = step;
    /* ADIM1_KILIT (Ali 2026-08-17): 1. adimda gorsel TASINAMAZ/KIRPILAMAZ.
       Olcu ve yon henuz secilmedi; burada yapilan hizalama 2. adimda oran
       degisince fillFrame ile ZATEN bozuluyordu -> hem kafa karistirici hem bosa
       emek. 2. adimdan itibaren geri acilir. Sekil/malzeme ayrimi GEREKMEZ,
       kapi adim bazli (Ali: "kare de de rectangular'da da var"). */
    if (state.img) {
      var _duz = step >= 2;
      state.img.set({ selectable: _duz, evented: _duz });
      try { if (_duz) { canvas.setActiveObject(state.img); } else { canvas.discardActiveObject(); } } catch (_e) {}
      canvas.renderAll();
    }
    document.querySelectorAll('.ip-step').forEach(function (s) { s.hidden = +s.dataset.step !== step; });
    document.querySelectorAll('#ip-dots li').forEach(function (li) {
      var n = +li.dataset.step;
      li.classList.toggle('on', n === step);
      li.classList.toggle('done', n < step);
    });
    /* ⚠ YAPIŞKAN ÖNİZLEME YALNIZ 2. ADIMDAN İTİBAREN (Ali 2026-07-31):
       1. adımda (format seçimi) fotoğraf henüz yok, önizlemenin yapışması gereksiz —
       ÖLÇÜLDÜ: kart 377px yer kaplıyor (ekranın %45'i) ve format karolarını ORTADAN
       KESİYORDU, sayfa bozuk görünüyordu. Artık fotoğrafın önemli olduğu adımlarda
       yapışıyor ve o haldeyken daha kısa. */
    var kok = document.getElementById('ip-root');
    if (kok) {
      var oncekiSinif = kok.classList.contains('ip-sticky-preview');
      /* ⭐ 3. ADIMDA DÜZENLEME TUVALİ YOK (Ali 2026-08-01): son adımda yalnız
         "Print preview" ve "3D Material view" görünür. Tuval orada dururken malzeme
         görünümü onun ARKASINDA kalıyordu. Hizalamayı değiştirmek isteyen BİR ÖNCEKİ
         adıma döner — böylece son adım sade ve tek işlevli olur. */
      kok.classList.toggle('ip-sticky-preview', step === 2);
      kok.classList.toggle('ip-step3', step === 3);
      /* ⚠ Sınıf değişince SAHNE YÜKSEKLİĞİ de değişiyor (34svh → 26svh). fabric tuvali
         yalnız window resize'da yeniden ölçülüyordu → tuval eski yükseklikte kalıp
         kartın alt kenarından KESİLİYORDU. CSS uygulandıktan sonra elle yeniden ölç. */
      if (oncekiSinif !== kok.classList.contains('ip-sticky-preview')) {
        requestAnimationFrame(function () { setTimeout(layout, 60); });
      }
    }

    /* mobil: yeni adımın ilk kontrolüne kaydır */
    ipKaydir(step === 1 ? document.getElementById('ip-formats')
           : step === 2 ? (state.img ? ipIlkKontrol()
                                     : document.getElementById('ip-upload-grid'))
           : document.querySelector('.ip-step[data-step="3"]'), 320);   /* son adımda BLOĞUN BAŞINA (başlık+sekmeler görünsün) */
    if (step === 3) {
      sendOriginal();          // niyet belli → baskı dosyası arka planda hazırlanıyor
      state.previewUrl = renderPrintResult(2);
      state.wrapUrl = null;
      var fin = document.getElementById('ip-final');
      fin.className = 'ip-final' + (state.frame.shape === 'round' ? ' round' : '');
      document.getElementById('ip-final-img').src = state.previewUrl || '';
      if (state.material === 'canvas') {
        // kanvasta BASKININ TAMAMI gösterilir: paylar + mirror + ters logo
        buildCanvasWrap(function (u) {
          state.wrapUrl = u;
          if (state.step === 3) {
            document.getElementById('ip-final-img').src = u;
            if (!document.getElementById('ip-3d').hidden) setView('3d'); // 3B açıksa tazele
          }
        });
      }
      document.getElementById('ip-final-cap').textContent =
        curFmt().product + ' ' + curFmt().name + ' · ' +
        (olcuBas(state.size, curFmt())) + ' · ' +
        MATERIALS[state.material].name + ' · ' + money(pFiyat(state.size, 'price'));
      document.getElementById('ip-note-txt').textContent = MATERIALS[state.material].note;
      setView('print');
    }
    renderPrice(); updateBar();
  }

  /* önizleme sekmeleri: Print / 3B malzeme */
  function setView(v) {
    document.querySelectorAll('.ip-vtab').forEach(function (t) {
      t.classList.toggle('active', t.dataset.view === v);
    });
    var d3 = document.getElementById('ip-3d'), fin = document.getElementById('ip-final');
    if (v === '3d') {
      d3.hidden = false; fin.hidden = true;
      if (window.IP3D) {
        var isCv = state.material === 'canvas' && state.wrapUrl;
        window.IP3D.show(d3, {
          texUrl: isCv ? state.wrapUrl : state.previewUrl,
          wMM: state.size.w + (isCv ? 160 : 0),
          hMM: state.size.h + (isCv ? 160 : 0),
          kind: curFmt().kind, material: state.material,
          panels: curFmt().panels || null,
        });
      }
    } else {
      d3.hidden = true; fin.hidden = false;
      if (window.IP3D) window.IP3D.hide();
    }
  }
  function updateBar() {
    var next = document.getElementById('ip-next'), back = document.getElementById('ip-back');
    var ipucu = document.getElementById('ip-next-hint');
    back.hidden = state.step === 1;
    /* ⚠ FOOLPROOF (Ali 2026-07-31): önceden format+ölçü SEÇİLİ geliyordu ve "Continue"
       hiçbir seçim yapılmadan aktifti — müşteri farkında olmadan varsayılanla ilerleyebiliyordu.
       Artık her adımda GEREKEN seçim yapılmadan buton açılmıyor ve NEDEN kapalı olduğu yazıyor. */
    var eksik = '';
    if (state.step === 1) {
      next.textContent = IPT('ipj_continue','Continue');
      if (!state.matChosen) eksik = IPT('ipj_need_material','Choose a material to continue');
      else if (!state.fmtChosen) eksik = IPT('ipj_need_format','Choose a shape to continue');
    } else if (state.step === 2) {
      next.textContent = IPT('ipj_preview','Preview — ') + money(pFiyat(state.size, 'price'));
      if (!state.img) eksik = IPT('ipj_need_photo','Add your photo to continue');
      else if (!state.sizeChosen) eksik = IPT('ipj_need_size','Choose a size to continue');
    } else {
      next.textContent = IPT('ipj_addcart','Add To Cart — ') + money(pFiyat(state.size, 'price'));
      if (!state.img) eksik = IPT('ipj_need_photo','Add your photo to continue');
    }
    next.disabled = !!eksik;
    if (ipucu) { ipucu.textContent = eksik; ipucu.hidden = !eksik; }
  }

  /* ── Shopify sepeti ──
     Varyant haritası backend'den gelir (malzeme|format|ölçü → varyant ID); ürün TASLAK
     'custom-print-personalizer'. Editör mağaza temasında çalışırken /cart/add.js AYNI ORİJİN'dedir;
     yerelde mağaza yok → gerçek istek atılmaz, ne gönderileceği gösterilir (dev modu). */
  var VMAP = null;
  fetch(API + '/variant-map.json').then(function (r) { return r.ok ? r.json() : null; })
    .then(function (j) { VMAP = j; }).catch(function () {});

  function onShopify() { return !!(window.Shopify && window.Shopify.routes); }
  function cartUrl(p) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + p;
  }
  function variantId() {
    if (!VMAP) return null;
    return VMAP.variants[state.material + '|' + curFmt().id + '|' + state.size.id] || null;
  }

  /* Baskı native çözünürlükten üretiliyor → sepete eklemeden önce ORİJİNAL sunucuda
     olmalı. Genelde önizleme adımında çoktan bitmiştir; bitmediyse kısa süre bekletiriz. */
  function ensureOriginal(cb) {
    if (!state.upload || !state.upload.needs_original || origState === 'done') { cb(true); return; }
    if (!origFile) {                                   // yenileme sonrası dosya elimizde yok
      toast(IPT('ipj_reselect','Please re-select your photo so we can prepare the print file'));
      document.getElementById('ip-file-lib').click();
      cb(false); return;
    }
    sendOriginal();
    var next = document.getElementById('ip-next');
    next.disabled = true; next.textContent = IPT('ipj_preparing','Preparing your file…');
    var t0 = Date.now();
    (function poll() {
      if (origState === 'done') { cb(true); return; }
      if (origState === 'failed') { toast(IPT('ipj_upload_fail','Could not upload your photo — please try again')); updateBar(); cb(false); return; }
      if (Date.now() - t0 > 180000) { toast(IPT('ipj_slow','Upload is taking long — please check your connection')); updateBar(); cb(false); return; }
      setTimeout(poll, 400);
    })();
  }


  /* ── MİNİ SEPETİ AÇ ─────────────────────────────────────────────────
     Ali (2026-07-30): sepete eklenince sepet SAYFASINA gitmek yanlış — müşteri
     akıştan kopuyor. Bunun yerine temanın kendi mini sepeti açılır.
     Tema-bağımsız olması için sırayla denenir:
       1) Halo/Ella (CANLI tema): halo.updateSidebarCart(cart) + body.cart-sidebar-show
       2) Dawn: <cart-drawer>.open()
       3) temaların dinlediği yaygın olaylar + başlıktaki sepet ikonuna tıklama
       4) hiçbiri açmadıysa SON ÇARE sepet sayfası (müşteri asla ürünü kaybetmesin) */
  function miniCartOpen() {
    var mc = document.querySelector('[data-minicart]');
    /* ⚠ ÖLÇÜLDÜ (2026-07-30): temanın minicart'ı önce `hidden`'ı kaldırıyor, `is-open`
       sınıfını ise ÇİFT requestAnimationFrame sonra ekliyor (cinematic-product.js
       open()). Sadece sınıfa bakınca "açılmadı" sanıp bir sonraki adıma geçiliyordu.
       `hidden` kalkmış olması = açılıyor demektir. */
    if (mc && !mc.hidden) return true;
    if (mc && (mc.classList.contains('is-open') || mc.classList.contains('open') ||
               mc.getAttribute('aria-hidden') === 'false')) return true;
    return document.body.classList.contains('cart-sidebar-show') ||
      !!document.querySelector('cart-drawer.active, cart-drawer[open], .cart-drawer.is-open, ' +
        '.cart-sidebar.is-open, #cart-sidebar.is-open, .drawer.is-open');
  }
  function openMiniCart() {
    fetch(cartUrl('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (cart) {
        /* ⚠⚠ KÖK NEDEN (Ali: "minicart açılmadı, doğrudan sepet sayfasını açtı"):
           adımlar ART ARDA SENKRON çalışıyordu. Tema mini sepeti açarken animasyon
           için birkaç kare bekliyor; o kareler geçmeden bir sonraki adıma geçilip
           `a[href$="/cart"]` bağlantısına tıklanıyordu → SAYFA DEĞİŞİYORDU.
           Artık her adımdan sonra 250ms bekleniyor ve gezinme yapan bağlantıya
           ASLA tıklanmıyor (sepet sayfasına düşmek yalnız en sondaki son çare). */
        var adimlar = [
          function () {                          // 1) Halo / Ella (canlı tema)
            if (cart && window.halo && typeof window.halo.updateSidebarCart === 'function') {
              window.halo.updateSidebarCart(cart);
              document.body.classList.add('cart-sidebar-show');
            }
          },
          function () {                          // 2) Dawn <cart-drawer>
            var d = document.querySelector('cart-drawer');
            if (d && typeof d.open === 'function') d.open();
          },
          function () {                          // 3) TEMANIN KENDİ mini sepeti
            /* Bu temada Dawn'ın <cart-drawer>'ı YOK: cinematic-header kendi minicart'ını
               render ediyor ("replaces Dawn header-group + cart-drawer"). Açma düğmesi
               [data-minicart-open] — bir <button>, gezinme yapmaz. */
            var b = document.querySelector('[data-minicart-open]');
            if (b && b.click) b.click();
          },
          function () {                          // 4) genel olaylar + çekmece düğmeleri
            ['cart:refresh', 'cart:build', 'cart:open', 'cart:updated', 'ajaxProduct:added']
              .forEach(function (ev) {
                try { document.dispatchEvent(new CustomEvent(ev, { bubbles: true, detail: { cart: cart } })); } catch (e) {}
              });
            var icon = document.querySelector('[data-cart-sidebar], .js-drawer-open-cart, ' +
              '.header__icon--cart, .site-header__cart');   /* ⚠ a[href$="/cart"] YOK: gezinir */
            if (icon && icon.click) icon.click();
          }
        ];
        var i = 0;
        (function sonraki() {
          if (miniCartOpen()) { updateBar(); return; }
          if (i >= adimlar.length) {
            setTimeout(function () {             // 5) hiçbiri açmadı → son çare sepet sayfası
              if (!miniCartOpen()) window.location.href = cartUrl('/cart');
              else updateBar();
            }, 400);
            return;
          }
          try { adimlar[i++](); } catch (e) {}
          setTimeout(sonraki, 250);              // temanın animasyonuna zaman tanı
        })();
      });
  }
  /* teşhis kancası (tarayıcıda ölçüm için; kullanıcı arayüzünü etkilemez) */
  window.__ipOpenMiniCart = openMiniCart;
  window.__ipMiniCartOpen = miniCartOpen;

  function addToCart() {
    if (!state.img) return;
    ensureOriginal(function (ok) { if (ok) doAddToCart(); });
  }

  function doAddToCart() {
    var next = document.getElementById('ip-next');
    var vid = variantId();
    if (VMAP && !vid) { toast(IPT('ipj_combo','This combination is not available yet')); return; }
    next.disabled = true; next.textContent = IPT('ipj_saving','Saving…');
    fetch(API + '/design', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ recipe: buildRecipe(), preview_data_url: state.previewUrl || renderPrintResult(2) }),
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        window.__ipLast = j;
        // _ ile başlayan property'ler müşteriye gösterilmez ama Liquid/sipariş API'sinde OKUNUR.
        var props = {
          _design_id: j.design_id,
          _design_preview: absUrl(j.preview_public_url),
          // sepet/mail görselini doğru oranda gösterebilmek için (Liquid en-boy hesaplayamaz)
          _design_ar: (state.size.w / state.size.h).toFixed(4),
          _recipe_v: 1,
        };
        var payload = { items: [{ id: vid, quantity: 1, properties: props }] };
        window.__ipCartPayload = payload;
        if (!onShopify()) {                       // yerel geliştirme: mağaza yok
          next.textContent = 'Added ✓ (dev)';
          toast('Design ' + j.design_id + ' saved ✓ — cart payload ready (variant ' + vid + ')');
          setTimeout(updateBar, 2500);
          return;
        }
        next.textContent = IPT('ipj_adding','Adding…');
        return fetch(cartUrl('/cart/add.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }).then(function (r) {
          return r.json().then(function (b) {
            if (!r.ok) throw new Error(b.description || b.message || r.status);
            toast(IPT('ipj_added_cart','Added to your cart ✓'));
            next.textContent = 'Added ✓';
            openMiniCart();                 // sepet SAYFASINA atlamıyoruz (Ali 2026-07-30)
          });
        });
      })
      .catch(function (e) { toast('Could not add to cart: ' + e.message); updateBar(); });
  }
  function absUrl(u) {
    if (!u) return '';
    return /^https?:\/\//.test(u) ? u : (API || window.location.origin).replace(/\/$/, '') + u;
  }

  /* ── zoom + pinch ── */
  function ratio() { return state.img.scaleX / coverScale(state.frame, state.img); }
  function syncZoom() {
    var z = document.getElementById('ip-zoom');
    z.value = state.img ? Math.min(4, Math.max(1, ratio())) : 1;
  }
  function setZoom(r) {
    if (!state.img) return;
    var base = coverScale(state.frame, state.img);
    state.img.scaleX = state.img.scaleY = base * Math.min(4, Math.max(1, r));
    constrain(); liftDecor(); canvas.requestRenderAll();
  }
  function wirePinch() {
    var ptrs = new Map(), startDist = 0, startRatio = 1;
    stageEl.addEventListener('pointerdown', function (e) { ptrs.set(e.pointerId, e); }, true);
    stageEl.addEventListener('pointermove', function (e) {
      if (!ptrs.has(e.pointerId)) return;
      ptrs.set(e.pointerId, e);
      if (ptrs.size === 2 && state.img) {
        var a = Array.from(ptrs.values());
        var d = Math.hypot(a[0].clientX - a[1].clientX, a[0].clientY - a[1].clientY);
        if (!startDist) { startDist = d; startRatio = ratio(); return; }
        canvas.discardActiveObject();
        setZoom(startRatio * (d / startDist));
        syncZoom();
      }
    }, true);
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      stageEl.addEventListener(ev, function (e) { ptrs.delete(e.pointerId); if (ptrs.size < 2) startDist = 0; }, true);
    });
  }

  /* ── yardımcılar ── */
  function busy(on) { document.getElementById('ip-busy').hidden = !on; }
  var toastT;
  function toast(m) {
    var el = document.getElementById('ip-toast'); el.textContent = m; el.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove('show'); }, 3200);
  }
  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

  /* ── kablolama ── */
  function wire() {
    var cam = document.getElementById('ip-file-cam'), lib = document.getElementById('ip-file-lib');
    /* YUKLEME_KILIDI: kilitliyken dosya secici HIC acilmasin (uploadFile'daki erken
       cikis son savunma; kullaniciyi bos yere secim ekranina sokmayalim). */
    document.getElementById('ip-btn-cam').onclick = function () { if (_ipYukleniyor) return; cam.click(); };
    document.getElementById('ip-btn-lib').onclick = function () { if (_ipYukleniyor) return; lib.click(); };
    [cam, lib].forEach(function (inp) {
      inp.onchange = function (e) { var f = e.target.files && e.target.files[0]; if (f) uploadFile(f); inp.value = ''; };
    });
    stageEl.addEventListener('click', function () {
      if (_ipYukleniyor) return;   /* YUKLEME_KILIDI */
      if (!state.img && state.step === 2) lib.click();
    });
    ['dragover', 'dragenter'].forEach(function (ev) { stageEl.addEventListener(ev, function (e) { e.preventDefault(); }); });
    stageEl.addEventListener('drop', function (e) {
      e.preventDefault();
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f && /image|heic|heif/i.test(f.type + f.name)) uploadFile(f);
    });

    document.querySelectorAll('.ip-tool').forEach(function (btn) {
      btn.onclick = function () {
        var img = state.img;
        if (btn.dataset.act === 'replace') { if (!_ipYukleniyor) lib.click(); return; }
        if (!img) return;
        switch (btn.dataset.act) {
          case 'fill': fillFrame(); break;
          case 'rot': img.rotate(((img.angle || 0) + 90) % 360); fillFrame(); break;
          case 'flip': img.set('flipX', !img.flipX); canvas.requestRenderAll(); break;
          case 'center': img.set({ left: state.frame.x + state.frame.w / 2, top: state.frame.y + state.frame.h / 2 });
            constrain(); liftDecor(); canvas.requestRenderAll(); break;
        }
        syncZoom();
      };
    });
    document.getElementById('ip-orient').addEventListener('click', function (e) {
      var b = e.target.closest('.ip-ob'); if (b) setOrient(b.dataset.o);
    });
    document.getElementById('ip-replace2').onclick = function () { lib.click(); };
    document.getElementById('ip-zoom').oninput = function (e) { setZoom(parseFloat(e.target.value)); };

    document.getElementById('ip-next').onclick = function () {
      if (state.step < 3) go(state.step + 1); else addToCart();
    };
    document.getElementById('ip-back').onclick = function () { if (state.step > 1) go(state.step - 1); };
    document.getElementById('ip-dots').addEventListener('click', function (e) {
      var li = e.target.closest('li'); if (!li) return;
      var hedef = +li.dataset.step;
      if (!adimIzinli(hedef)) { var u = adimUyari(hedef); if (u) toast(u); return; }
      go(hedef);
    });
    document.getElementById('ip-mats').addEventListener('click', function (e) {
      var b = e.target.closest('.ip-mat'); if (!b) return;
      /* ⭐ SIRA DEĞİŞTİ (Ali 2026-08-01): ÖNCE MALZEME, sonra o malzemeye uygun ŞEKİLLER.
         Malzeme değişince şekil seçimi SIFIRLANIR — yoksa müşteri, seçtiği malzemede
         olmayan bir şekille devam edebilir. */
      state.material = b.dataset.mat;
      state.matChosen = true;
      /* MALZEME_KALICI_UYUM: malzeme gizlenmedigi icin ARTIK uyumsuz malzeme de
         secilebiliyor. Mevcut format yeni malzemede yoksa remapSize'in listesi BOS
         doner ve list[0] undefined -> setSize(undefined) -> computeFrame patlar.
         Formati yeni malzemenin ILK UYGUN formatina tasiyoruz.
         ⚠ fmtChosen BILEREK false kalir: sekil yeniden secilmeli (Ali'nin istegi). */
      if (!sizesFor(state.material, curFmt().id)) {
        for (var _fi = 0; _fi < FORMATS.length; _fi++) {
          if (sizesFor(state.material, FORMATS[_fi].id)) { state.fmtIdx = _fi; break; }
        }
      }
      var kok0 = document.getElementById('ip-root'); if (kok0) kok0.classList.add('ip-mat-chosen');
      state.fmtChosen = false;
      state.sizeChosen = false;
      document.querySelectorAll('.ip-mat').forEach(function (m) { m.classList.toggle('active', m === b); });
      renderStrip(); renderFormats(); remapSize(); renderOrient(); renderPrice(); updateBar(); saveSession();
    });
    document.querySelectorAll('.ip-vtab').forEach(function (t) {
      t.onclick = function () { setView(t.dataset.view); };
    });

    canvas.on('object:moving', function () { constrain(); liftDecor(); });
    canvas.on('object:scaling', function () { constrain(); liftDecor(); syncZoom(); });
    canvas.on('object:modified', function () { constrain(); liftDecor(); syncZoom(); saveSession(); });
    wirePinch();
  }

  /* ── başlat ── */
  layout();
  renderFormats(); syncMaterialAvail(); renderChips(); renderOrient(); renderPrice(); renderStrip();
  state.matChosen = false; state.fmtChosen = false; state.sizeChosen = false;
  (function(){ var k = document.getElementById('ip-root'); if (k) k.classList.remove('ip-mat-chosen'); })();  // hiçbir şey ön-seçili DEĞİL
  setSize(FORMATS[0].sizes[0], false);                 // yalnız sahnenin geometrisi için
  wire();
  go(1);
  restoreSession();          // önceki fotoğraf/seçimler varsa geri getir (yoksa hiçbir şey olmaz)

  window.__ipRecipe = buildRecipe;
  window.__ip = { canvas: canvas, state: state, constrain: constrain, coverScale: coverScale,
    placementGet: placementGet, go: go, setFormat: setFormat, FORMATS: FORMATS,
    variantId: variantId, vmap: function () { return VMAP; }, addToCart: addToCart };
})();
